'use strict';

var React = require('react');
var require$$0 = require('buffer');

function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return exports;
  };
  var exports = {},
    Op = Object.prototype,
    hasOwn = Op.hasOwnProperty,
    $Symbol = "function" == typeof Symbol ? Symbol : {},
    iteratorSymbol = $Symbol.iterator || "@@iterator",
    asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
    toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }
  try {
    define({}, "");
  } catch (err) {
    define = function (obj, key, value) {
      return obj[key] = value;
    };
  }
  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
      generator = Object.create(protoGenerator.prototype),
      context = new Context(tryLocsList || []);
    return generator._invoke = function (innerFn, self, context) {
      var state = "suspendedStart";
      return function (method, arg) {
        if ("executing" === state) throw new Error("Generator is already running");
        if ("completed" === state) {
          if ("throw" === method) throw arg;
          return doneResult();
        }
        for (context.method = method, context.arg = arg;;) {
          var delegate = context.delegate;
          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);
            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }
          if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
            if ("suspendedStart" === state) throw state = "completed", context.arg;
            context.dispatchException(context.arg);
          } else "return" === context.method && context.abrupt("return", context.arg);
          state = "executing";
          var record = tryCatch(innerFn, self, context);
          if ("normal" === record.type) {
            if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
            return {
              value: record.arg,
              done: context.done
            };
          }
          "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
        }
      };
    }(innerFn, self, context), generator;
  }
  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }
  exports.wrap = wrap;
  var ContinueSentinel = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
    NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }
  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if ("throw" !== record.type) {
        var result = record.arg,
          value = result.value;
        return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }
      reject(record.arg);
    }
    var previousPromise;
    this._invoke = function (method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function (resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }
      return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
    };
  }
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (undefined === method) {
      if (context.delegate = null, "throw" === context.method) {
        if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel;
        context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method");
      }
      return ContinueSentinel;
    }
    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }
  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }
  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }
  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;
      if (!isNaN(iterable.length)) {
        var i = -1,
          next = function next() {
            for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
            return next.value = undefined, next.done = !0, next;
          };
        return next.next = next;
      }
    }
    return {
      next: doneResult
    };
  }
  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (object) {
    var keys = [];
    for (var key in object) keys.push(key);
    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function (skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function () {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function (exception) {
      if (this.done) throw exception;
      var context = this;
      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
          record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");
        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
            hasFinally = hasOwn.call(entry, "finallyLoc");
          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function (type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }
      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function (record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function (finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function (tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function (iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}

function binReader(data) {
  var pos = 0;

  function end() {
    return pos >= data.length;
  }

  function seek(p) {
    if (p > data.length) throw new Error("out of range: " + p);
    pos = p;
  }

  function byte() {
    if (pos >= data.length) throw new Error("out of range");
    return data.charCodeAt(pos++);
  }

  function unbyte() {
    if (pos < 0) throw new Error("out of range");
    return data.charCodeAt(pos--);
  }

  function seq(n) {
    if (pos + n > data.length) throw new Error("out of range");
    pos += n;
    return data.substr(pos - n, n);
  }

  function skip(n) {
    pos += n;
  }

  function binFloat64le() {
    var sign, exp, mant, b;

    skip(7);
    b = unbyte();
    sign = b >> 7;
    exp = b & 127;
    b = unbyte();
    exp <<= 4;
    exp |= b >> 4;
    mant = b & 15;
    for (b = 0; b < 6; b++) {
      mant *= 1 << 8;
      mant += unbyte();
    }
    skip(9);
    return (
      (sign ? -1 : 1) * Math.pow(2, exp - 1023) * (1 + mant * Math.pow(2, -52))
    );
  }

  function binFloat32le() {
    var sign, exp, mant, b;

    skip(3);
    b = unbyte();
    sign = b >> 7;
    exp = b & 127;
    b = unbyte();
    exp <<= 1;
    exp |= b >> 7;
    mant = b & 127;
    for (b = 0; b < 2; b++) {
      mant *= 1 << 8;
      mant += unbyte();
    }
    skip(5);
    return (
      (sign ? -1 : 1) * Math.pow(2, exp - 127) * (1 + mant * Math.pow(2, -23))
    );
  }

  function word32le() {
    return word16le() | (word16le() << 16);
  }

  function word16le() {
    return byte() | (byte() << 8);
  }

  function int32le() {
    var r = word32le();
    return r > 1 << 31 ? r - (1 << 32) : r;
  }

  function int16le() {
    var r = word16le();
    return r > 1 << 15 ? r - (1 << 16) : r;
  }

  function int8() {
    var r = byte();
    return r > 1 << 7 ? r - (1 << 8) : r;
  }

  function string(max) {
    if (max === undefined) max = Infinity;
    for (
      var n = 0;
      n < max && pos + n < data.length && data[pos + n] != "\u0000";
      n++
    );
    return seq(n);
  }

  function pstring(n) {
    var s = seq(n);
    return (n = s.indexOf("\u0000")) >= 0 ? s.substr(0, n) : s;
  }

  return {
    end: end,
    seek: seek,
    byte: byte,
    seq: seq,
    skip: skip,
    binFloat64le: binFloat64le,
    binFloat32le: binFloat32le,
    word32le: word32le,
    word16le: word16le,
    int32le: int32le,
    int16le: int16le,
    int8: int8,
    string: string,
    pstring: pstring,
    pos: function() {
      return pos;
    }
  };
}

function levReader(data) {
  var br = binReader(data);

  var ticker = (function() {
    var n = 0;
    return function(m) {
      n += m;
      return n - m;
    };
  })();

  var offsType = ticker(5);
  function levVersion() {
    br.seek(offsType);
    return br.seq(5);
  }
  var elma = levVersion() == "POT14";
  if (elma) ticker(2);
  var offsIdent = ticker(4);
  var offsIntegrities = ticker(4 * 8);
  var descLength = elma ? 51 : 15;
  var offsDesc = ticker(descLength);
  if (elma) {
    var offsLgr = ticker(16);
    var offsGround = ticker(10);
    var offsSky = ticker(10);
  }
  else ticker(44); // Across lev

  var offsPolyCount = ticker(8);
  var offsPolys = ticker(0);

  function polyCount() {
    br.seek(offsPolyCount);
    return Math.floor(br.binFloat64le());
  }

  function objCount() {
    br.seek(offsObjCount);
    return Math.floor(br.binFloat64le());
  }

  function picCount() {
    if (elma) {
      br.seek(offsPicCount);
      return Math.floor(br.binFloat64le());
    } else return 0;
  }

  var offsObjCount = (function() {
    var pc = polyCount();
    br.seek(offsPolys);
    for (var x = 0; x < pc; x++) {
      if (elma) br.skip(4); // grass
      br.skip(br.word32le() * (8 + 8));
    }
    return br.pos();
  })();
  var offsObjs = offsObjCount + 8;
  var offsPicCount = elma ? (function() {
    br.seek(offsObjCount);
    return offsObjs + Math.floor(br.binFloat64le()) * (8 + 8 + (4 + 4 + 4));
  })() : 0;
  var offsPics = offsPicCount + 8;

  var obj, pic; // initialised in the object literal :\

  return (window.lrd = {
    rightType: function() {
      return ["POT14", "POT06"].indexOf(levVersion()) >= 0;
    },

    ident: function() {
      br.seek(offsIdent);
      return br.seq(4);
    },

    integrities: function() {
      br.seek(offsIntegrities);
      var o = [];
      for (var x = 0; x < 4; x++) o.push(br.binFloat64le());
      return o;
    },

    desc: function() {
      br.seek(offsDesc);
      return br.string(descLength);
    },

    lgr: function() {
      if (elma) {
        br.seek(offsLgr);
        return br.string(16).toLowerCase();
      } else return "default";
    },

    ground: function() {
      if (elma) {
        br.seek(offsGround);
        return br.string(10).toLowerCase();
      } else return "ground";
    },

    sky: function() {
      if (elma) {
        br.seek(offsSky);
        return br.string(10).toLowerCase();
      } else return "sky";
    },

    polyCount: polyCount,
    objCount: objCount,
    picCount: picCount,

    polyReader: function(forEachPoly) {
      /* lr.polyReader(function(grass, vcount, vertices){
				 *   // for each polygon
				 *   vertices(function(x, y){
				 *     // for each vertex in it
				 *   });
				 * });
				 */

      var count = polyCount();
      br.seek(offsPolys);
      for (var x = 0; x < count; x++) {
        var grass = elma ? br.word32le() : 0,
          vcount = br.word32le(),
          pos = br.pos();
        void (function(grass, vcount, pos) {
          br.seek(pos);
          forEachPoly(grass != 0, vcount, function(forEachVertex) {
            for (var y = 0; y < vcount; y++) {
              br.seek(pos + y * (8 + 8));
              forEachVertex(br.binFloat64le(), br.binFloat64le());
            }
          });
        })(grass, vcount, pos);
        br.seek(pos + vcount * (8 + 8));
      }
    },

    obj: (obj = function(n, onFlower, onApple, onKiller, onStart) {
      // onError? maybe
      br.seek(offsObjs + n * (8 + 8 + (elma ? (4 + 4 + 4) : 4)));
      var vx = br.binFloat64le(),
        vy = br.binFloat64le();
      var obj = br.word32le(),
        grav = elma ? br.word32le() : 0,
        anim = elma ? br.word32le() : 0;
      switch (obj) {
        case 1:
          return onFlower(vx, vy);
        case 2:
          return onApple(vx, vy, grav, anim);
        case 3:
          return onKiller(vx, vy);
        case 4:
          return onStart(vx, vy);
        default:
          throw new Error("hmm: " + obj + ", x = " + vx + ", y = " + vy);
      }
    }),

    obj_: function(n) {
      function h(s) {
        return function(vx, vy, grav, anim) {
          var o = { type: s, x: vx, y: vy };
          if (grav !== undefined) {
            o.grav = grav;
            o.anim = anim;
          }
          return o;
        };
      }

      return obj(n, h("flower"), h("apple"), h("killer"), h("start"));
    },

    pic: (pic = function(n, onPic) {
      br.seek(offsPics + n * (10 + 10 + 10 + 8 + 8 + 4 + 4));
      var picture = br.pstring(10).toLowerCase(),
        texture = br.pstring(10).toLowerCase(),
        mask = br.pstring(10).toLowerCase();
      var vx = br.binFloat64le(),
        vy = br.binFloat64le();
      var dist = br.word32le(),
        clipping = br.word32le();
      clipping = ["u", "g", "s"][clipping];
      return onPic(picture, texture, mask, vx, vy, dist, clipping);
    }),

    pic_: function(n) {
      return pic(n, function(picture, texture, mask, vx, vy, dist, clipping) {
        return {
          picture: picture,
          texture: texture,
          mask: mask,
          x: vx,
          y: vy,
          dist: dist,
          clipping: clipping
        };
      });
    }
  });
}

var ticker = (function() {
  var n = 0;
  return function(m) {
    n += m;
    return n - m;
  };
})();

ticker(4);
ticker(4);
ticker(8);
ticker(4);
ticker(16);
var goffsFloat32s = ticker(0);

function recReader(data) {
  var br = binReader(data);

  return readerFrom(0);

  function readerFrom(beginPos) {
    var offsFloat32s = beginPos + goffsFloat32s;

    br.seek(beginPos);
    if (beginPos < 0 || br.end()) return null;
    var frameCount = br.word32le();

    var gticker = (function() {
      var offs = offsFloat32s;

      return function(size, count, reader) {
        var offs_ = offs;
        offs += size * count * frameCount;
        return function(n) {
          return function(frame) {
            br.seek(offs_ + size * (n * frameCount + frame));
            return reader();
          };
        };
      };
    })();

    var float32s = gticker(4, 2, br.binFloat32le); // bikeX, bikeY
    var int16s = gticker(2, 7, br.int16le); // leftX, leftY, rightX, rightY, headX, headY, bikeR
    var word8s = gticker(1, 5, br.byte); // leftR, rightR, turn, unk1, unk2

    var eventCount = gticker(4, 1, br.word32le)(0)(0); // heh
    var offsEvents = br.pos();

    function event(n, fn) {
      br.seek(offsEvents + n * (8 + 4 + 4));
      return fn(
        br.binFloat64le(),
        br.word16le(),
        br.byte(),
        br.byte(),
        br.binFloat32le()
      );
    }

    return {
      frameCount: function() {
        return frameCount;
      },

      bikeX: float32s(0),
      bikeY: float32s(1),

      leftX: int16s(0),
      leftY: int16s(1),
      rightX: int16s(2),
      rightY: int16s(3),
      headX: int16s(4),
      headY: int16s(5),
      bikeR: int16s(6),

      leftR: word8s(0),
      rightR: word8s(1),
      turn: word8s(2),

      eventCount: function() {
        return eventCount;
      },

      event: event,

      event_: function(n) {
        return event(n, function(time, info, type, _, dunno) {
          return {
            time: time,
            info: info,
            type: type,
            dunno: dunno
          };
        });
      },

      next: readerFrom(offsEvents + eventCount * (8 + 4 + 4) + 4)
    };
  }
}

// crude way to get files as binary strings, compatible with binReader.js
const getString = function(url, fn) {
  var xhr = new XMLHttpRequest();
  xhr.onreadystatechange = function() {
    if (xhr.readyState == 4)
      fn(
        xhr.responseText
          .split("")
          .map(function(c) {
            return String.fromCharCode(c.charCodeAt(0) & 0xff);
          })
          .join("")
      );
  };
  xhr.open("GET", url);
  xhr.overrideMimeType("text/plain; charset=x-user-defined");
  xhr.send(null);
};

// more modern Uint8Array
const getArray = function (url, fn, error) {
  var xhr = new XMLHttpRequest();
  xhr.responseType = "arraybuffer";

  xhr.onload = function () {
    if (xhr.status !== 200) {
      if(error) {
        error();
      }
      return
    }
    fn(new Uint8Array(xhr.response));
  };

  xhr.open("GET", url);
  xhr.send();
};

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var lib = {};

var lev = {};

var ElmaObject = {};

var shared = {};

(function (exports) {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.OBJECT_RADIUS = exports.OBJECT_DIAMETER = exports.HEAD_RADIUS = exports.HEAD_DIAMETER = exports.Clip = exports.Position = void 0;
	/**
	 * Simple point with x and y coordinates
	 */
	var Position = /** @class */ (function () {
	    function Position(x, y) {
	        if (x === void 0) { x = 0; }
	        if (y === void 0) { y = 0; }
	        this.x = x;
	        this.y = y;
	    }
	    return Position;
	}());
	exports.Position = Position;
	(function (Clip) {
	    Clip[Clip["Unclipped"] = 0] = "Unclipped";
	    Clip[Clip["Ground"] = 1] = "Ground";
	    Clip[Clip["Sky"] = 2] = "Sky";
	})(exports.Clip || (exports.Clip = {}));
	// Bike diameters and radii.
	exports.HEAD_DIAMETER = 0.476;
	exports.HEAD_RADIUS = 0.238;
	exports.OBJECT_DIAMETER = 0.8;
	exports.OBJECT_RADIUS = 0.4;
	
} (shared));

(function (exports) {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.Gravity = exports.ObjectType = void 0;
	var shared_1 = shared;
	var ObjectType;
	(function (ObjectType) {
	    ObjectType[ObjectType["Exit"] = 1] = "Exit";
	    ObjectType[ObjectType["Apple"] = 2] = "Apple";
	    ObjectType[ObjectType["Killer"] = 3] = "Killer";
	    ObjectType[ObjectType["Start"] = 4] = "Start";
	})(ObjectType = exports.ObjectType || (exports.ObjectType = {}));
	var Gravity;
	(function (Gravity) {
	    Gravity[Gravity["None"] = 0] = "None";
	    Gravity[Gravity["Up"] = 1] = "Up";
	    Gravity[Gravity["Down"] = 2] = "Down";
	    Gravity[Gravity["Left"] = 3] = "Left";
	    Gravity[Gravity["Right"] = 4] = "Right";
	})(Gravity = exports.Gravity || (exports.Gravity = {}));
	var ElmaObject = /** @class */ (function () {
	    function ElmaObject() {
	        this.position = new shared_1.Position();
	        this.type = ObjectType.Apple;
	        this.gravity = Gravity.None;
	        this.animation = 1;
	    }
	    return ElmaObject;
	}());
	exports.default = ElmaObject;
	
} (ElmaObject));

var Picture$1 = {};

Object.defineProperty(Picture$1, "__esModule", { value: true });
var shared_1 = shared;
var Picture = /** @class */ (function () {
    function Picture() {
        this.name = 'barrel';
        this.texture = '';
        this.mask = '';
        this.position = new shared_1.Position(0, 0);
        this.distance = 600;
        this.clip = shared_1.Clip.Sky;
        this.grass = false;
        this.vertices = [];
    }
    return Picture;
}());
Picture$1.default = Picture;

var Polygon$1 = {};

Object.defineProperty(Polygon$1, "__esModule", { value: true });
var Polygon = /** @class */ (function () {
    function Polygon() {
        this.grass = false;
        this.vertices = [];
    }
    return Polygon;
}());
Polygon$1.default = Polygon;

var Level = {};

var hasRequiredLevel;

function requireLevel () {
	if (hasRequiredLevel) return Level;
	hasRequiredLevel = 1;
	(function (exports) {
		var __read = (commonjsGlobal && commonjsGlobal.__read) || function (o, n) {
		    var m = typeof Symbol === "function" && o[Symbol.iterator];
		    if (!m) return o;
		    var i = m.call(o), r, ar = [], e;
		    try {
		        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
		    }
		    catch (error) { e = { error: error }; }
		    finally {
		        try {
		            if (r && !r.done && (m = i["return"])) m.call(i);
		        }
		        finally { if (e) throw e.error; }
		    }
		    return ar;
		};
		var __values = (commonjsGlobal && commonjsGlobal.__values) || function(o) {
		    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
		    if (m) return m.call(o);
		    if (o && typeof o.length === "number") return {
		        next: function () {
		            if (o && i >= o.length) o = void 0;
		            return { value: o && o[i++], done: !o };
		        }
		    };
		    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
		};
		Object.defineProperty(exports, "__esModule", { value: true });
		exports.Version = void 0;
		var buffer_1 = require$$0;
		var __1 = requireLib();
		var EOD_MARKER = 0x0067103a; // level data marker
		var EOF_MARKER = 0x00845d52; // level file marker
		var Version;
		(function (Version) {
		    Version[Version["Across"] = 0] = "Across";
		    Version[Version["Elma"] = 1] = "Elma";
		})(Version = exports.Version || (exports.Version = {}));
		var Level = /** @class */ (function () {
		    function Level() {
		        this.version = Version.Elma;
		        this.link = 0;
		        this.integrity = [0, 0, 0, 0];
		        this.lgr = 'default';
		        this.name = 'Unnamed level';
		        this.ground = 'ground';
		        this.sky = 'sky';
		        this.polygons = [
		            {
		                grass: false,
		                vertices: [new __1.Position(10, 0), new __1.Position(10, 7), new __1.Position(0, 7), new __1.Position(0, 0)],
		            },
		        ];
		        this.objects = [
		            {
		                animation: 1,
		                gravity: __1.Gravity.None,
		                position: new __1.Position(2, 0 + __1.OBJECT_RADIUS),
		                type: __1.ObjectType.Start,
		            },
		            {
		                animation: 1,
		                gravity: __1.Gravity.None,
		                position: new __1.Position(8, 0 + __1.OBJECT_RADIUS),
		                type: __1.ObjectType.Exit,
		            },
		        ];
		        this.pictures = [];
		        this.top10 = {
		            multi: [],
		            single: [],
		        };
		    }
		    /**
		     * Loads a level from a buffer representation of the file.
		     * @param buffer
		     */
		    Level.from = function (buffer) {
		        return this.parseBuffer(buffer_1.Buffer.from(buffer));
		    };
		    /**
		     * Encrypts or decrypts top10 lists
		     */
		    Level.cryptTop10 = function (buffer) {
		        var output = buffer_1.Buffer.from(buffer); // copy buffer to not modify reference
		        var ebp8 = 0x15;
		        var ebp10 = 0x2637;
		        for (var i = 0; i < 688; i++) {
		            output[i] ^= ebp8 & 0xff;
		            // sick domi modifications to work with JS
		            ebp10 += (ebp8 % 0xd3d) * 0xd3d;
		            ebp8 = ebp10 * 0x1f + 0xd3d;
		            ebp8 = (ebp8 & 0xffff) - 2 * (ebp8 & 0x8000);
		        }
		        return output;
		    };
		    Level.parseBuffer = function (buffer) {
		        var level = new Level();
		        // remove default polygons and objects
		        level.polygons = [];
		        level.objects = [];
		        var offset = 0;
		        var version = buffer.toString('ascii', 0, 5);
		        switch (version) {
		            case 'POT06':
		                level.version = Version.Across;
		                throw new Error('Across levels are not supported');
		            case 'POT14':
		                level.version = Version.Elma;
		                break;
		            default:
		                throw new Error('Not valid Elma level');
		        }
		        offset += 7; // +2 extra unused bytes
		        level.link = buffer.readUInt32LE(offset);
		        offset += 4;
		        for (var i = 0; i < 4; i++) {
		            level.integrity[i] = buffer.readDoubleLE(offset);
		            offset += 8;
		        }
		        level.name = __1.trimString(buffer.slice(offset, offset + 51));
		        offset += 51;
		        level.lgr = __1.trimString(buffer.slice(offset, offset + 16));
		        offset += 16;
		        level.ground = __1.trimString(buffer.slice(offset, offset + 10));
		        offset += 10;
		        level.sky = __1.trimString(buffer.slice(offset, offset + 10));
		        offset += 10;
		        var polyCount = buffer.readDoubleLE(offset) - 0.4643643;
		        offset += 8;
		        var _a = __read(this.parsePolygons(buffer, offset, polyCount), 2), polygons = _a[0], readBytes = _a[1];
		        level.polygons = polygons;
		        offset = readBytes;
		        var objectCount = buffer.readDoubleLE(offset) - 0.4643643;
		        offset += 8;
		        level.objects = this.parseObjects(buffer, offset, objectCount);
		        offset += objectCount * 28;
		        var picCount = buffer.readDoubleLE(offset) - 0.2345672;
		        offset += 8;
		        level.pictures = this.parsePictures(buffer, offset, picCount);
		        offset += picCount * 54;
		        if (buffer.readInt32LE(offset) !== EOD_MARKER) {
		            throw new Error('End of data marker mismatch');
		        }
		        offset += 4;
		        var top10Data = Level.cryptTop10(buffer.slice(offset, offset + 688));
		        level.top10 = __1.bufferToTop10(top10Data);
		        offset += 688;
		        if (buffer.readInt32LE(offset) !== EOF_MARKER) {
		            throw new Error('End of file marker mismatch');
		        }
		        return level;
		    };
		    Level.parsePolygons = function (buffer, readBytes, polyCount) {
		        var polygons = [];
		        for (var i = 0; i < polyCount; i++) {
		            var polygon = new __1.Polygon();
		            polygon.grass = Boolean(buffer.readInt32LE(readBytes));
		            readBytes += 4;
		            var vertexCount = buffer.readInt32LE(readBytes);
		            readBytes += 4;
		            for (var j = 0; j < vertexCount; j++) {
		                var x = buffer.readDoubleLE(readBytes);
		                readBytes += 8;
		                var y = buffer.readDoubleLE(readBytes);
		                readBytes += 8;
		                polygon.vertices.push(new __1.Position(x, y));
		            }
		            polygons.push(polygon);
		        }
		        return [polygons, readBytes];
		    };
		    Level.parseObjects = function (buffer, offset, objectCount) {
		        var objects = [];
		        for (var i = 0; i < objectCount; i++) {
		            var elmaObject = new __1.ElmaObject();
		            elmaObject.position.x = buffer.readDoubleLE(offset);
		            offset += 8;
		            elmaObject.position.y = buffer.readDoubleLE(offset);
		            offset += 8;
		            elmaObject.type = buffer.readInt32LE(offset);
		            if (elmaObject.type < 1 || elmaObject.type > 4) {
		                throw new Error("Invalid object type value=" + elmaObject.type + " at offset=" + offset);
		            }
		            offset += 4;
		            elmaObject.gravity = buffer.readInt32LE(offset);
		            if (elmaObject.gravity < 0 || elmaObject.gravity > 4) {
		                throw new Error("Invalid gravity value=" + elmaObject.gravity + " at offset=" + offset);
		            }
		            offset += 4;
		            elmaObject.animation = buffer.readInt32LE(offset) + 1;
		            offset += 4;
		            objects.push(elmaObject);
		        }
		        return objects;
		    };
		    Level.parsePictures = function (buffer, offset, picCount) {
		        var pictures = [];
		        for (var i = 0; i < picCount; i++) {
		            var picture = new __1.Picture();
		            picture.name = __1.trimString(buffer.slice(offset, offset + 10));
		            offset += 10;
		            picture.texture = __1.trimString(buffer.slice(offset, offset + 10));
		            offset += 10;
		            picture.mask = __1.trimString(buffer.slice(offset, offset + 10));
		            offset += 10;
		            picture.position.x = buffer.readDoubleLE(offset);
		            offset += 8;
		            picture.position.y = buffer.readDoubleLE(offset);
		            offset += 8;
		            picture.distance = buffer.readInt32LE(offset);
		            offset += 4;
		            picture.clip = buffer.readInt32LE(offset);
		            if (picture.clip < 0 || picture.clip > 2) {
		                throw new Error("Invalid clip value=" + picture.clip + " at offset=" + offset);
		            }
		            offset += 4;
		            pictures.push(picture);
		        }
		        return pictures;
		    };
		    /**
		     * Returns a buffer representation of the level.
		     */
		    Level.prototype.toBuffer = function () {
		        var e_1, _a, e_2, _b, e_3, _c, e_4, _d, e_5, _e;
		        var integrity = this.calculateIntegrity();
		        var bufferSize = 850; // all known level attributes' size
		        try {
		            for (var _f = __values(this.polygons), _g = _f.next(); !_g.done; _g = _f.next()) {
		                var polygon = _g.value;
		                bufferSize += 8 + 16 * polygon.vertices.length;
		            }
		        }
		        catch (e_1_1) { e_1 = { error: e_1_1 }; }
		        finally {
		            try {
		                if (_g && !_g.done && (_a = _f.return)) _a.call(_f);
		            }
		            finally { if (e_1) throw e_1.error; }
		        }
		        bufferSize += 28 * this.objects.length + 54 * this.pictures.length;
		        var buffer = buffer_1.Buffer.alloc(bufferSize);
		        if (this.version !== Version.Elma) {
		            throw new Error('Only Elma levels are supported');
		        }
		        buffer.write('POT14', 0, 5, 'ascii');
		        buffer.writeUInt16LE(this.link & 0xffff, 5);
		        buffer.writeUInt32LE(this.link, 7);
		        for (var i = 0; i < integrity.length; i++) {
		            buffer.writeDoubleLE(integrity[i], 11 + i * 8);
		        }
		        var name = __1.nullpadString(this.name, 51);
		        buffer.write(name, 43, 51, 'ascii');
		        var lgr = __1.nullpadString(this.lgr, 16);
		        buffer.write(lgr, 94, 16, 'ascii');
		        var ground = __1.nullpadString(this.ground, 10);
		        buffer.write(ground, 110, 10, 'ascii');
		        var sky = __1.nullpadString(this.sky, 10);
		        buffer.write(sky, 120, 10, 'ascii');
		        buffer.writeDoubleLE(this.polygons.length + 0.4643643, 130);
		        var offset = 138; // unknown territory, time to keep track of offset!
		        try {
		            for (var _h = __values(this.polygons), _j = _h.next(); !_j.done; _j = _h.next()) {
		                var polygon = _j.value;
		                buffer.writeInt32LE(polygon.grass ? 1 : 0, offset);
		                offset += 4;
		                buffer.writeInt32LE(polygon.vertices.length, offset);
		                offset += 4;
		                try {
		                    for (var _k = (e_3 = void 0, __values(polygon.vertices)), _l = _k.next(); !_l.done; _l = _k.next()) {
		                        var vertex = _l.value;
		                        buffer.writeDoubleLE(vertex.x, offset);
		                        offset += 8;
		                        buffer.writeDoubleLE(vertex.y, offset);
		                        offset += 8;
		                    }
		                }
		                catch (e_3_1) { e_3 = { error: e_3_1 }; }
		                finally {
		                    try {
		                        if (_l && !_l.done && (_c = _k.return)) _c.call(_k);
		                    }
		                    finally { if (e_3) throw e_3.error; }
		                }
		            }
		        }
		        catch (e_2_1) { e_2 = { error: e_2_1 }; }
		        finally {
		            try {
		                if (_j && !_j.done && (_b = _h.return)) _b.call(_h);
		            }
		            finally { if (e_2) throw e_2.error; }
		        }
		        buffer.writeDoubleLE(this.objects.length + 0.4643643, offset);
		        offset += 8;
		        try {
		            for (var _m = __values(this.objects), _o = _m.next(); !_o.done; _o = _m.next()) {
		                var obj = _o.value;
		                buffer.writeDoubleLE(obj.position.x, offset);
		                offset += 8;
		                buffer.writeDoubleLE(obj.position.y, offset);
		                offset += 8;
		                buffer.writeInt32LE(obj.type, offset);
		                offset += 4;
		                buffer.writeInt32LE(obj.gravity, offset);
		                offset += 4;
		                buffer.writeInt32LE(obj.animation - 1, offset);
		                offset += 4;
		            }
		        }
		        catch (e_4_1) { e_4 = { error: e_4_1 }; }
		        finally {
		            try {
		                if (_o && !_o.done && (_d = _m.return)) _d.call(_m);
		            }
		            finally { if (e_4) throw e_4.error; }
		        }
		        buffer.writeDoubleLE(this.pictures.length + 0.2345672, offset);
		        offset += 8;
		        try {
		            for (var _p = __values(this.pictures), _q = _p.next(); !_q.done; _q = _p.next()) {
		                var picture = _q.value;
		                var picName = __1.nullpadString(picture.name, 10);
		                buffer.write(picName, offset, 10, 'ascii');
		                offset += 10;
		                var texture = __1.nullpadString(picture.texture, 10);
		                buffer.write(texture, offset, 10, 'ascii');
		                offset += 10;
		                var mask = __1.nullpadString(picture.mask, 10);
		                buffer.write(mask, offset, 10, 'ascii');
		                offset += 10;
		                buffer.writeDoubleLE(picture.position.x, offset);
		                offset += 8;
		                buffer.writeDoubleLE(picture.position.y, offset);
		                offset += 8;
		                buffer.writeInt32LE(picture.distance, offset);
		                offset += 4;
		                buffer.writeInt32LE(picture.clip, offset);
		                offset += 4;
		            }
		        }
		        catch (e_5_1) { e_5 = { error: e_5_1 }; }
		        finally {
		            try {
		                if (_q && !_q.done && (_e = _p.return)) _e.call(_p);
		            }
		            finally { if (e_5) throw e_5.error; }
		        }
		        buffer.writeInt32LE(EOD_MARKER, offset);
		        offset += 4;
		        var top10Buffer = __1.top10ToBuffer(this.top10);
		        var encryptedTop10Buffer = Level.cryptTop10(top10Buffer);
		        encryptedTop10Buffer.copy(buffer, offset);
		        offset += 688;
		        buffer.writeInt32LE(EOF_MARKER, offset);
		        return buffer;
		    };
		    /**
		     * Calculates the integrity sums of the level.
		     * NOTE: Does not currently detect topology errors.
		     */
		    Level.prototype.calculateIntegrity = function () {
		        var e_6, _a, e_7, _b, e_8, _c, e_9, _d;
		        var polygonSum = 0;
		        try {
		            for (var _e = __values(this.polygons), _f = _e.next(); !_f.done; _f = _e.next()) {
		                var polygon = _f.value;
		                try {
		                    for (var _g = (e_7 = void 0, __values(polygon.vertices)), _h = _g.next(); !_h.done; _h = _g.next()) {
		                        var vertex = _h.value;
		                        polygonSum += vertex.x + vertex.y;
		                    }
		                }
		                catch (e_7_1) { e_7 = { error: e_7_1 }; }
		                finally {
		                    try {
		                        if (_h && !_h.done && (_b = _g.return)) _b.call(_g);
		                    }
		                    finally { if (e_7) throw e_7.error; }
		                }
		            }
		        }
		        catch (e_6_1) { e_6 = { error: e_6_1 }; }
		        finally {
		            try {
		                if (_f && !_f.done && (_a = _e.return)) _a.call(_e);
		            }
		            finally { if (e_6) throw e_6.error; }
		        }
		        var objectSum = 0;
		        try {
		            for (var _j = __values(this.objects), _k = _j.next(); !_k.done; _k = _j.next()) {
		                var levelObject = _k.value;
		                var objectValue = 0;
		                if (levelObject.type === __1.ObjectType.Exit)
		                    objectValue = 1;
		                else if (levelObject.type === __1.ObjectType.Apple)
		                    objectValue = 2;
		                else if (levelObject.type === __1.ObjectType.Killer)
		                    objectValue = 3;
		                else if (levelObject.type === __1.ObjectType.Start)
		                    objectValue = 4;
		                objectSum += levelObject.position.x + levelObject.position.y + objectValue;
		            }
		        }
		        catch (e_8_1) { e_8 = { error: e_8_1 }; }
		        finally {
		            try {
		                if (_k && !_k.done && (_c = _j.return)) _c.call(_j);
		            }
		            finally { if (e_8) throw e_8.error; }
		        }
		        var pictureSum = 0;
		        try {
		            for (var _l = __values(this.pictures), _m = _l.next(); !_m.done; _m = _l.next()) {
		                var picture = _m.value;
		                pictureSum += picture.position.x + picture.position.y;
		            }
		        }
		        catch (e_9_1) { e_9 = { error: e_9_1 }; }
		        finally {
		            try {
		                if (_m && !_m.done && (_d = _l.return)) _d.call(_l);
		            }
		            finally { if (e_9) throw e_9.error; }
		        }
		        var sum = (polygonSum + objectSum + pictureSum) * 3247.764325643;
		        return [
		            sum,
		            this.getRandomInt(0, 5871) + 11877 - sum,
		            this.getRandomInt(0, 5871) + 11877 - sum,
		            this.getRandomInt(0, 6102) + 12112 - sum,
		        ];
		    };
		    /**
		     * Returns a random number in [min..max] range
		     */
		    Level.prototype.getRandomInt = function (min, max) {
		        min = Math.ceil(min);
		        max = Math.floor(max);
		        return Math.floor(Math.random() * (max - min)) + min;
		    };
		    return Level;
		}());
		exports.default = Level;
		
} (Level));
	return Level;
}

var hasRequiredLev;

function requireLev () {
	if (hasRequiredLev) return lev;
	hasRequiredLev = 1;
	(function (exports) {
		var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
		    return (mod && mod.__esModule) ? mod : { "default": mod };
		};
		Object.defineProperty(exports, "__esModule", { value: true });
		exports.Version = exports.Level = exports.Polygon = exports.Picture = exports.ObjectType = exports.Gravity = exports.ElmaObject = void 0;
		var ElmaObject_1 = ElmaObject;
		Object.defineProperty(exports, "ElmaObject", { enumerable: true, get: function () { return __importDefault(ElmaObject_1).default; } });
		Object.defineProperty(exports, "Gravity", { enumerable: true, get: function () { return ElmaObject_1.Gravity; } });
		Object.defineProperty(exports, "ObjectType", { enumerable: true, get: function () { return ElmaObject_1.ObjectType; } });
		var Picture_1 = Picture$1;
		Object.defineProperty(exports, "Picture", { enumerable: true, get: function () { return __importDefault(Picture_1).default; } });
		var Polygon_1 = Polygon$1;
		Object.defineProperty(exports, "Polygon", { enumerable: true, get: function () { return __importDefault(Polygon_1).default; } });
		var Level_1 = requireLevel();
		Object.defineProperty(exports, "Level", { enumerable: true, get: function () { return __importDefault(Level_1).default; } });
		Object.defineProperty(exports, "Version", { enumerable: true, get: function () { return Level_1.Version; } });
		
} (lev));
	return lev;
}

var rec = {};

var Event = {};

(function (exports) {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.EventType = void 0;
	var Event = /** @class */ (function () {
	    function Event() {
	        this.type = 0;
	        this.time = 0;
	        this.touchInfo = 0;
	        this.groundInfo = 0;
	    }
	    return Event;
	}());
	exports.default = Event;
	(function (EventType) {
	    EventType[EventType["Touch"] = 0] = "Touch";
	    EventType[EventType["Ground"] = 1] = "Ground";
	    EventType[EventType["Apple"] = 4] = "Apple";
	    EventType[EventType["Turn"] = 5] = "Turn";
	    EventType[EventType["VoltRight"] = 6] = "VoltRight";
	    EventType[EventType["VoltLeft"] = 7] = "VoltLeft";
	})(exports.EventType || (exports.EventType = {}));
	
} (Event));

var Frame = {};

(function (exports) {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.Direction = void 0;
	var shared_1 = shared;
	(function (Direction) {
	    Direction[Direction["Left"] = 0] = "Left";
	    Direction[Direction["Right"] = 1] = "Right";
	})(exports.Direction || (exports.Direction = {}));
	var Frame = /** @class */ (function () {
	    function Frame() {
	        // TODO: maybe figure out "default" positions as they are in-game
	        this.bike = new shared_1.Position(0, 0);
	        this.leftWheel = new shared_1.Position(0, 0);
	        this.rightWheel = new shared_1.Position(0, 0);
	        this.head = new shared_1.Position(0, 0);
	        this.bikeRotation = 0;
	        this.leftWheelRotation = 0;
	        this.rightWheelRotation = 0;
	        this.backWheelSpeed = 0;
	        this.collisionStrength = 0;
	        this.throttleAndDirection = 0;
	    }
	    Object.defineProperty(Frame.prototype, "throttle", {
	        get: function () {
	            return (this.throttleAndDirection & 1) !== 0;
	        },
	        set: function (throttle) {
	            this.throttleAndDirection = (this.throttleAndDirection & ~1) | (throttle ? 1 : 0);
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(Frame.prototype, "direction", {
	        get: function () {
	            return this.throttleAndDirection & (1 << 1);
	        },
	        set: function (direction) {
	            this.throttleAndDirection = (this.throttleAndDirection & ~(1 << 2)) | (direction << 2);
	        },
	        enumerable: false,
	        configurable: true
	    });
	    return Frame;
	}());
	exports.default = Frame;
	
} (Frame));

var Ride$1 = {};

Object.defineProperty(Ride$1, "__esModule", { value: true });
var Ride = /** @class */ (function () {
    function Ride() {
        this.frames = [];
        this.events = [];
    }
    return Ride;
}());
Ride$1.default = Ride;

var Replay = {};

var util = {};

Object.defineProperty(util, "__esModule", { value: true });
util.bufferToTop10 = util.bufferToTop10Part = util.top10ToBuffer = util.trimString = util.nullpadString = util.formatTime = void 0;
var buffer_1 = require$$0;
/**
 * Formats time to string.
 * Defaults to: '01:18,03' (mins:secs,hundredths)
 * If time is longer than 1hr will add hours in front: '23:51:00,99'.
 */
function formatTime(time) {
    var hundredths = Math.trunc(time % 100);
    var seconds = Math.trunc((time / 100) % 60);
    var minutes = Math.trunc((time / (100 * 60)) % 60);
    var hours = Math.trunc(time / (100 * 60 * 60));
    return "" + (hours ? hours + ':' : '') + minutes.toString().padStart(2, '0') + ":" + seconds
        .toString()
        .padStart(2, '0') + "," + hundredths.toString().padStart(2, '0');
}
util.formatTime = formatTime;
/**
 * Pads a string with null-bytes, or returns a slice, with desired length.
 * @param str String to pad
 * @param length Desired string length
 */
function nullpadString(str, length) {
    if (!/^[\x00-\x7F]*$/.test(str)) {
        throw new Error('String contains non-ASCII values');
    }
    // if string is longer than padding, just return a slice of it
    if (str.length > length)
        return str.slice(0, length);
    return str.padEnd(length, '\x00');
}
util.nullpadString = nullpadString;
/**
 * Trims null-bytes and any following bytes from buffer and returns a string representation.
 */
function trimString(buffer) {
    var bufferObj = buffer_1.Buffer.from(buffer);
    var index = bufferObj.indexOf('\x00');
    return bufferObj.toString('ascii', 0, index !== -1 ? index : undefined);
}
util.trimString = trimString;
/**
 * Convert a Top10 best times list into a unencrypted buffer representation
 * @param top10
 */
function top10ToBuffer(top10) {
    var buffers = Object.values(top10).map(function (list) {
        // sort all the times first
        list.sort(function (a, b) {
            if (a.time > b.time)
                return 1;
            if (a.time < b.time)
                return -1;
            return 0;
        });
        var buffer = buffer_1.Buffer.alloc(344);
        buffer.writeUInt32LE(list.length >= 10 ? 10 : list.length, 0);
        for (var i = 0; i < list.length; i++) {
            if (i < 10) {
                buffer.writeUInt32LE(list[i].time, 4 + 4 * i);
                buffer.write(nullpadString(list[i].name1, 15), 44 + 15 * i);
                buffer.write(nullpadString(list[i].name2, 15), 194 + 15 * i);
            }
        }
        return buffer;
    });
    return buffer_1.Buffer.concat(buffers, 688);
}
util.top10ToBuffer = top10ToBuffer;
/**
 * Converts buffer to Top10 part. I.e. single-player or multi-player top10 times separately
 * @param buffer unencrypted Buffer of length 344
 */
function bufferToTop10Part(buffer) {
    var bufferObj = buffer_1.Buffer.from(buffer);
    if (bufferObj.length !== 344)
        throw Error("Top10 buffer length expected to be 344, got " + bufferObj.length);
    var entryCount = bufferObj.readInt32LE(0);
    var top10 = [];
    for (var i = 0; i < entryCount; i++) {
        var timeOffset = 4 + i * 4;
        var nameOneOffset = 44 + i * 15;
        var nameOneEnd = nameOneOffset + 15;
        var nameTwoOffset = 194 + i * 15;
        var nameTwoEnd = nameTwoOffset + 15;
        var time = bufferObj.readInt32LE(timeOffset);
        var name1 = trimString(bufferObj.slice(nameOneOffset, nameOneEnd));
        var name2 = trimString(bufferObj.slice(nameTwoOffset, nameTwoEnd));
        top10.push({ time: time, name1: name1, name2: name2 });
    }
    return top10;
}
util.bufferToTop10Part = bufferToTop10Part;
/**
 * Converts buffer to Top10
 * @param buffer unencrypted Buffer of length 688
 */
function bufferToTop10(buffer) {
    var bufferObj = buffer_1.Buffer.from(buffer);
    if (bufferObj.length !== 688)
        throw Error("Top10 buffer length expected to be 688, got " + bufferObj.length);
    var single = bufferToTop10Part(bufferObj.slice(0, 344));
    var multi = bufferToTop10Part(bufferObj.slice(344));
    return {
        single: single,
        multi: multi,
    };
}
util.bufferToTop10 = bufferToTop10;

var hasRequiredReplay;

function requireReplay () {
	if (hasRequiredReplay) return Replay;
	hasRequiredReplay = 1;
	(function (exports) {
		var __read = (commonjsGlobal && commonjsGlobal.__read) || function (o, n) {
		    var m = typeof Symbol === "function" && o[Symbol.iterator];
		    if (!m) return o;
		    var i = m.call(o), r, ar = [], e;
		    try {
		        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
		    }
		    catch (error) { e = { error: error }; }
		    finally {
		        try {
		            if (r && !r.done && (m = i["return"])) m.call(i);
		        }
		        finally { if (e) throw e.error; }
		    }
		    return ar;
		};
		var __spreadArray = (commonjsGlobal && commonjsGlobal.__spreadArray) || function (to, from) {
		    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
		        to[j] = from[i];
		    return to;
		};
		var __values = (commonjsGlobal && commonjsGlobal.__values) || function(o) {
		    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
		    if (m) return m.call(o);
		    if (o && typeof o.length === "number") return {
		        next: function () {
		            if (o && i >= o.length) o = void 0;
		            return { value: o && o[i++], done: !o };
		        }
		    };
		    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
		};
		Object.defineProperty(exports, "__esModule", { value: true });
		exports.ReplayFinishStateReason = void 0;
		var shared_1 = shared;
		var util_1 = util;
		var _1 = requireRec();
		var Event_1 = Event;
		var EOR_MARKER = 0x00492f75; // replay marker
		var ReplayFinishStateReason;
		(function (ReplayFinishStateReason) {
		    ReplayFinishStateReason["Touch"] = "Touch";
		    ReplayFinishStateReason["NoTouch"] = "NoTouch";
		    ReplayFinishStateReason["FrameDifference"] = "FrameDifference";
		})(ReplayFinishStateReason = exports.ReplayFinishStateReason || (exports.ReplayFinishStateReason = {}));
		var Replay = /** @class */ (function () {
		    function Replay() {
		        this.link = 0;
		        this.level = '';
		        this.isMulti = false;
		        this.isFlagTag = false;
		        this.rides = [];
		        this.path = '';
		    }
		    /**
		     * Loads a replay file.
		     * @param buffer BufferInput
		     */
		    Replay.from = function (buffer) {
		        return this.parseBuffer(Buffer.from(buffer));
		    };
		    Replay.parseBuffer = function (buffer) {
		        var rec = new Replay();
		        var offset = 0;
		        // support replays with more than 2 rides by continually trying to read ride data.
		        while (offset < buffer.length) {
		            var _a = __read(this.parseRide(buffer.slice(offset)), 2), header = _a[0], ride = _a[1];
		            Object.assign(rec, header);
		            rec.rides.push(ride);
		            offset += 44 + ride.frames.length * 27 + ride.events.length * 16;
		        }
		        return rec;
		    };
		    /**
		     * Parses a "ride", which consists of frames and events
		     */
		    Replay.parseRide = function (buffer) {
		        var ride = new _1.Ride();
		        var offset = 0;
		        var numFrames = buffer.readUInt32LE(offset);
		        offset += 8; // + 4 unused extra bytes
		        var isMulti = Boolean(buffer.readInt32LE(offset));
		        offset += 4;
		        var isFlagTag = Boolean(buffer.readInt32LE(offset));
		        offset += 4;
		        var link = buffer.readUInt32LE(offset);
		        offset += 4;
		        var level = util_1.trimString(buffer.slice(offset, offset + 12));
		        offset += 16; // + 4 unused extra bytes
		        var header = { isMulti: isMulti, isFlagTag: isFlagTag, link: link, level: level };
		        ride.frames = Replay.parseFrames(buffer.slice(offset, offset + 27 * numFrames), numFrames);
		        offset += 27 * numFrames;
		        var numEvents = buffer.readUInt32LE(offset);
		        offset += 4;
		        ride.events = Replay.parseEvents(buffer.slice(offset, offset + 16 * numEvents), numEvents);
		        offset += 16 * numEvents;
		        var expected = buffer.readInt32LE(offset);
		        if (expected !== EOR_MARKER) {
		            throw new Error('End of replay marker mismatch');
		        }
		        // offset += 4
		        return [header, ride];
		    };
		    Replay.parseFrames = function (buffer, numFrames) {
		        var frames = [];
		        for (var i = 0; i < numFrames; i++) {
		            var frame = new _1.Frame();
		            frame.bike = new shared_1.Position(buffer.readFloatLE(i * 4), buffer.readFloatLE(i * 4 + numFrames * 4));
		            frame.leftWheel = new shared_1.Position(buffer.readInt16LE(i * 2 + numFrames * 8), buffer.readInt16LE(i * 2 + numFrames * 10));
		            frame.rightWheel = new shared_1.Position(buffer.readInt16LE(i * 2 + numFrames * 12), buffer.readInt16LE(i * 2 + numFrames * 14));
		            frame.head = new shared_1.Position(buffer.readInt16LE(i * 2 + numFrames * 16), buffer.readInt16LE(i * 2 + numFrames * 18));
		            frame.bikeRotation = buffer.readInt16LE(i * 2 + numFrames * 20);
		            frame.leftWheelRotation = buffer.readUInt8(i + numFrames * 22);
		            frame.rightWheelRotation = buffer.readUInt8(i + numFrames * 23);
		            frame.throttleAndDirection = buffer.readUInt8(i + numFrames * 24);
		            frame.backWheelSpeed = buffer.readUInt8(i + numFrames * 25);
		            frame.collisionStrength = buffer.readUInt8(i + numFrames * 26);
		            frames.push(frame);
		        }
		        return frames;
		    };
		    Replay.parseEvents = function (buffer, numEvents) {
		        var events = [];
		        var offset = 0;
		        for (var i = 0; i < numEvents; i++) {
		            var time = buffer.readDoubleLE(offset);
		            offset += 8;
		            var touchInfo = buffer.readInt16LE(offset);
		            offset += 2;
		            var type = buffer.readUInt8(offset);
		            offset += 2; // 1 + 1 padding
		            var groundInfo = buffer.readFloatLE(offset);
		            offset += 4;
		            if (type < 0 || type > 7) {
		                throw new Error("Invalid event type value=" + type + " at event offset=" + offset);
		            }
		            events.push({ time: time, touchInfo: touchInfo, type: type, groundInfo: groundInfo });
		        }
		        return events;
		    };
		    /**
		     * Returns a buffer representation of the replay.
		     */
		    Replay.prototype.toBuffer = function () {
		        var _this = this;
		        // calculate how many bytes we need by checking each ride's frames and events
		        var bufferSize = this.rides.reduce(function (byteAcc, ride) {
		            var rideBytes = 44 + 27 * ride.frames.length + 16 * ride.events.length;
		            return byteAcc + rideBytes;
		        }, 0);
		        var buffer = Buffer.alloc(bufferSize);
		        var offset = 0;
		        this.rides.forEach(function (ride) {
		            var numFrames = ride.frames.length;
		            buffer.writeUInt32LE(numFrames, offset);
		            buffer.writeUInt32LE(0x83, offset + 4);
		            buffer.writeUInt32LE(_this.isMulti ? 1 : 0, offset + 8);
		            buffer.writeUInt32LE(_this.isFlagTag ? 1 : 0, offset + 12);
		            buffer.writeUInt32LE(_this.link, offset + 16);
		            buffer.write(util_1.nullpadString(_this.level, 12), offset + 20, 12, 'ascii');
		            buffer.writeUInt32LE(0, offset + 32);
		            offset += 36;
		            for (var i = 0; i < numFrames; i++) {
		                buffer.writeFloatLE(ride.frames[i].bike.x, offset + i * 4);
		                buffer.writeFloatLE(ride.frames[i].bike.y, offset + i * 4 + numFrames * 4);
		                buffer.writeInt16LE(ride.frames[i].leftWheel.x, offset + i * 2 + numFrames * 8);
		                buffer.writeInt16LE(ride.frames[i].leftWheel.y, offset + i * 2 + numFrames * 10);
		                buffer.writeInt16LE(ride.frames[i].rightWheel.x, offset + i * 2 + numFrames * 12);
		                buffer.writeInt16LE(ride.frames[i].rightWheel.y, offset + i * 2 + numFrames * 14);
		                buffer.writeInt16LE(ride.frames[i].head.x, offset + i * 2 + numFrames * 16);
		                buffer.writeInt16LE(ride.frames[i].head.y, offset + i * 2 + numFrames * 18);
		                buffer.writeInt16LE(ride.frames[i].bikeRotation, offset + i * 2 + numFrames * 20);
		                buffer.writeUInt8(ride.frames[i].leftWheelRotation, offset + i + numFrames * 22);
		                buffer.writeUInt8(ride.frames[i].rightWheelRotation, offset + i + numFrames * 23);
		                buffer.writeUInt8(ride.frames[i].throttleAndDirection, offset + i + numFrames * 24);
		                buffer.writeUInt8(ride.frames[i].backWheelSpeed, offset + i + numFrames * 25);
		                buffer.writeUInt8(ride.frames[i].collisionStrength, offset + i + numFrames * 26);
		            }
		            offset += 27 * numFrames;
		            buffer.writeUInt32LE(ride.events.length, offset);
		            offset += 4;
		            ride.events.forEach(function (event) {
		                buffer.writeDoubleLE(event.time, offset);
		                offset += 8;
		                var defaultInfo = -1;
		                var defaultInfo2 = 0.99;
		                switch (event.type) {
		                    case Event_1.EventType.Touch:
		                        buffer.writeInt16LE(event.touchInfo, offset);
		                        buffer.writeUInt8(event.type, offset + 2);
		                        buffer.writeUInt8(0, offset + 3);
		                        buffer.writeFloatLE(0, offset + 4);
		                        break;
		                    case Event_1.EventType.Ground:
		                        buffer.writeInt16LE(defaultInfo, offset);
		                        buffer.writeUInt8(event.type, offset + 2);
		                        buffer.writeUInt8(0, offset + 3);
		                        buffer.writeFloatLE(event.groundInfo, offset + 4);
		                        break;
		                    default:
		                        buffer.writeInt16LE(defaultInfo, offset);
		                        buffer.writeUInt8(event.type, offset + 2);
		                        buffer.writeUInt8(0, offset + 3);
		                        buffer.writeFloatLE(defaultInfo2, offset + 4);
		                        break;
		                }
		                offset += 8;
		            });
		            buffer.writeUInt32LE(EOR_MARKER, offset);
		            offset += 4;
		        });
		        return buffer;
		    };
		    /**
		     * Get time of replay in milliseconds.
		     */
		    Replay.prototype.getTime = function () {
		        // First check if last event was a touch event in ride(s) event data.
		        var lastEvent = this.rides.reduce(function (prev, ride) {
		            var prevTime = prev ? prev.time : 0;
		            var lastRideEvent = ride.events.length > 0 ? ride.events[ride.events.length - 1] : undefined;
		            var lastRideEventTime = lastRideEvent ? lastRideEvent.time : 0;
		            if (lastRideEventTime > prevTime) {
		                return lastRideEvent;
		            }
		            return prev;
		        }, undefined);
		        // Highest frame time.
		        var maxFrames = this.rides.reduce(function (prev, ride) {
		            return ride.frames.length > prev ? ride.frames.length : prev;
		        }, 0);
		        var maxFrameTime = maxFrames * 33.333;
		        // If no touch event, return approximate frame time.
		        if ((lastEvent && lastEvent.type !== Event_1.EventType.Touch) || !lastEvent) {
		            return {
		                finished: false,
		                reason: ReplayFinishStateReason.NoTouch,
		                time: Math.round(maxFrameTime),
		            };
		        }
		        // Set to highest event time.
		        var maxEventTime = lastEvent.time * (0.001 / (0.182 * 0.0024)) * 1000;
		        // If event difference to frame time is >1 frames of time, probably not finished?
		        if (maxFrameTime > maxEventTime + 33.333) {
		            return {
		                finished: false,
		                reason: ReplayFinishStateReason.FrameDifference,
		                time: Math.round(maxFrameTime),
		            };
		        }
		        // Otherwise probably finished?
		        return {
		            finished: true,
		            reason: ReplayFinishStateReason.Touch,
		            time: Math.floor(maxEventTime),
		        };
		    };
		    Object.defineProperty(Replay.prototype, "apples", {
		        /**
		         * Returns the number of apples collected in the replay.
		         *
		         * @returns Number of apples
		         */
		        get: function () {
		            var e_1, _a;
		            var apples = 0;
		            var _loop_1 = function (ride) {
		                var touchEvents = ride.events.filter(function (event) { return event.type === 0; }).sort(function (a, b) { return b.time - a.time; });
		                var appleEvents = ride.events.filter(function (event) { return event.type === 4; });
		                var unique = __spreadArray([], __read(new Set(touchEvents.map(function (event) { return event.touchInfo; })))).map(function (event, idx) { return touchEvents[idx]; });
		                appleEvents.forEach(function (appleEvent) {
		                    var touchEventWithSameTime = unique.findIndex(function (touchEvent) {
		                        return touchEvent.time === appleEvent.time;
		                    });
		                    if (touchEventWithSameTime > -1) {
		                        unique.splice(touchEventWithSameTime, 1);
		                        apples += 1;
		                    }
		                });
		            };
		            try {
		                for (var _b = __values(this.rides), _c = _b.next(); !_c.done; _c = _b.next()) {
		                    var ride = _c.value;
		                    _loop_1(ride);
		                }
		            }
		            catch (e_1_1) { e_1 = { error: e_1_1 }; }
		            finally {
		                try {
		                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
		                }
		                finally { if (e_1) throw e_1.error; }
		            }
		            return apples;
		        },
		        enumerable: false,
		        configurable: true
		    });
		    Object.defineProperty(Replay.prototype, "totalApples", {
		        /**
		         * Returns the total number of apples collected in the replay (including "apple bugs")
		         */
		        get: function () {
		            var apples = this.rides.reduce(function (apples, ride) {
		                apples += ride.events.filter(function (event) { return event.type === 4; }).length;
		                return apples;
		            }, 0);
		            return apples;
		        },
		        enumerable: false,
		        configurable: true
		    });
		    return Replay;
		}());
		exports.default = Replay;
		
} (Replay));
	return Replay;
}

var hasRequiredRec;

function requireRec () {
	if (hasRequiredRec) return rec;
	hasRequiredRec = 1;
	(function (exports) {
		var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
		    return (mod && mod.__esModule) ? mod : { "default": mod };
		};
		Object.defineProperty(exports, "__esModule", { value: true });
		exports.ReplayFinishStateReason = exports.Replay = exports.Ride = exports.Direction = exports.Frame = exports.EventType = exports.Event = void 0;
		var Event_1 = Event;
		Object.defineProperty(exports, "Event", { enumerable: true, get: function () { return __importDefault(Event_1).default; } });
		Object.defineProperty(exports, "EventType", { enumerable: true, get: function () { return Event_1.EventType; } });
		var Frame_1 = Frame;
		Object.defineProperty(exports, "Frame", { enumerable: true, get: function () { return __importDefault(Frame_1).default; } });
		Object.defineProperty(exports, "Direction", { enumerable: true, get: function () { return Frame_1.Direction; } });
		var Ride_1 = Ride$1;
		Object.defineProperty(exports, "Ride", { enumerable: true, get: function () { return __importDefault(Ride_1).default; } });
		var Replay_1 = requireReplay();
		Object.defineProperty(exports, "Replay", { enumerable: true, get: function () { return __importDefault(Replay_1).default; } });
		Object.defineProperty(exports, "ReplayFinishStateReason", { enumerable: true, get: function () { return Replay_1.ReplayFinishStateReason; } });
		
} (rec));
	return rec;
}

var lgr = {};

var LGR = {};

var hasRequiredLGR;

function requireLGR () {
	if (hasRequiredLGR) return LGR;
	hasRequiredLGR = 1;
	var __read = (commonjsGlobal && commonjsGlobal.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	Object.defineProperty(LGR, "__esModule", { value: true });
	var buffer_1 = require$$0;
	var __1 = requireLib();
	var util_1 = util;
	// Magic arbitrary number to signify start of LGR file.
	var LGRStart = 0x000003ea;
	// Magic arbitrary number to signify end of LGR file.
	var LGREOF = 0x0b2e05e7;
	var LGR$1 = /** @class */ (function () {
	    function LGR() {
	        this.pictureList = [];
	        this.pictureData = [];
	        this.path = '';
	    }
	    /**
	     * Loads a LGR file from a buffer.
	     * @param buffer
	     */
	    LGR.from = function (buffer) {
	        return this.parseBuffer(buffer_1.Buffer.from(buffer));
	    };
	    LGR.parseBuffer = function (buffer) {
	        var lgr = new LGR();
	        var version = buffer.toString('ascii', 0, 5);
	        // there are no other LGR versions possible, so no need to store it (?)
	        if (version !== 'LGR12') {
	            throw new Error("Invalid LGR version: " + version);
	        }
	        var pictureLen = buffer.readInt32LE(5);
	        var expectedHeader = buffer.readInt32LE(9);
	        if (expectedHeader !== LGRStart) {
	            throw new Error("Invalid header: " + expectedHeader);
	        }
	        // picture.lst section
	        var listLen = buffer.readInt32LE(13);
	        lgr.pictureList = lgr.parseListData(buffer.slice(17, 17 + 26 * listLen), listLen);
	        // pcx data
	        var _a = __read(lgr.parsePictureData(buffer.slice(17 + 26 * listLen), pictureLen), 2), pictureData = _a[0], bytesRead = _a[1];
	        lgr.pictureData = pictureData;
	        var expectedEof = buffer.readInt32LE(17 + 26 * listLen + bytesRead);
	        if (expectedEof !== LGREOF) {
	            throw new Error("EOF marker expected at byte: " + (17 + 26 * listLen + bytesRead));
	        }
	        return lgr;
	    };
	    /**
	     * Returns a buffer representation of the LGR.
	     */
	    LGR.prototype.toBuffer = function () {
	        // calculate how many bytes to allocate:
	        // - 21 known static bytes, plus 26 bytes for each item in picture.lst
	        // - the image data is then reduced and added to that.
	        var pictureListLength = this.pictureList.length;
	        var bytesToAlloc = this.pictureData.reduce(function (bytes, picture) { return bytes + picture.data.length + 24; }, 21 + 26 * pictureListLength);
	        var buffer = buffer_1.Buffer.alloc(bytesToAlloc);
	        var offset = 0;
	        buffer.write('LGR12', offset, 5, 'ascii');
	        offset += 5;
	        buffer.writeUInt32LE(this.pictureData.length, offset);
	        offset += 4;
	        buffer.writeInt32LE(LGRStart, offset);
	        offset += 4;
	        buffer.writeUInt32LE(pictureListLength, offset);
	        offset += 4;
	        this.pictureList.forEach(function (pictureDeclaration, n) {
	            buffer.write(util_1.nullpadString(pictureDeclaration.name, 10), offset + n * 10, 10, 'ascii');
	            buffer.writeUInt32LE(pictureDeclaration.pictureType, offset + 10 * pictureListLength + 4 * n);
	            buffer.writeUInt32LE(pictureDeclaration.distance, offset + 14 * pictureListLength + 4 * n);
	            buffer.writeUInt32LE(pictureDeclaration.clipping, offset + 18 * pictureListLength + 4 * n);
	            buffer.writeUInt32LE(pictureDeclaration.transparency, offset + 22 * pictureListLength + 4 * n);
	        });
	        offset += 26 * pictureListLength;
	        this.pictureData.forEach(function (pictureData) {
	            buffer.write(util_1.nullpadString(pictureData.name, 20), offset, 20, 'ascii');
	            offset += 20;
	            buffer.writeUInt32LE(pictureData.data.length, offset);
	            offset += 4;
	            offset += pictureData.data.copy(buffer, offset);
	        });
	        buffer.writeInt32LE(LGREOF, offset);
	        return buffer;
	    };
	    LGR.prototype.parseListData = function (buffer, length) {
	        var pictureDeclarations = [];
	        var offset = 0;
	        var names = buffer.slice(offset, offset + length * 10);
	        offset += length * 10;
	        var pictureTypes = buffer.slice(offset, offset + length * 4);
	        offset += length * 4;
	        var distances = buffer.slice(offset, offset + length * 4);
	        offset += length * 4;
	        var clips = buffer.slice(offset, offset + length * 4);
	        offset += length * 4;
	        var transparencies = buffer.slice(offset, offset + length * 4);
	        for (var i = 0; i < length; i++) {
	            var pictureDeclaration = new __1.PictureDeclaration();
	            pictureDeclaration.name = util_1.trimString(names.slice(10 * i, 10 * i + 10));
	            pictureDeclaration.pictureType = pictureTypes.readInt32LE(i * 4);
	            pictureDeclaration.distance = distances.readInt32LE(i * 4);
	            pictureDeclaration.clipping = clips.readInt32LE(i * 4);
	            pictureDeclaration.transparency = transparencies.readInt32LE(i * 4);
	            pictureDeclarations.push(pictureDeclaration);
	        }
	        return pictureDeclarations;
	    };
	    LGR.prototype.parsePictureData = function (buffer, length) {
	        var pictures = [];
	        var offset = 0;
	        for (var i = 0; i < length; i++) {
	            var name = util_1.trimString(buffer.slice(offset, offset + 12));
	            offset += 20; // +8 garbage (?) bytes
	            var bytesToRead = buffer.readUInt32LE(offset);
	            offset += 4;
	            var data = buffer.slice(offset, offset + bytesToRead);
	            pictures.push(new __1.PictureData(name, data));
	            offset += bytesToRead;
	        }
	        // we need to return amount of bytes read in order to correctly get the offset later.
	        return [pictures, offset];
	    };
	    return LGR;
	}());
	LGR.default = LGR$1;
	
	return LGR;
}

var PictureData$1 = {};

Object.defineProperty(PictureData$1, "__esModule", { value: true });
var PictureData = /** @class */ (function () {
    function PictureData(name, buffer) {
        this.name = name;
        this.data = buffer;
    }
    return PictureData;
}());
PictureData$1.default = PictureData;

var PictureDeclaration = {};

(function (exports) {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.Transparency = exports.PictureType = void 0;
	var shared_1 = shared;
	var PictureType;
	(function (PictureType) {
	    PictureType[PictureType["Normal"] = 100] = "Normal";
	    PictureType[PictureType["Texture"] = 101] = "Texture";
	    PictureType[PictureType["Mask"] = 102] = "Mask";
	})(PictureType = exports.PictureType || (exports.PictureType = {}));
	var Transparency;
	(function (Transparency) {
	    // No transparency. Only valid for ´Mask´ picture types.
	    Transparency[Transparency["Solid"] = 10] = "Solid";
	    // Palette index 0 is transparent color.
	    Transparency[Transparency["Palette"] = 11] = "Palette";
	    // Top left pixel is transparent color.
	    Transparency[Transparency["TopLeft"] = 12] = "TopLeft";
	    // Top right pixel is transparent color.
	    Transparency[Transparency["TopRight"] = 13] = "TopRight";
	    // Bottom left pixel is transparent color.
	    Transparency[Transparency["BottomLeft"] = 14] = "BottomLeft";
	    // Bottom right pixel is transparent color.
	    Transparency[Transparency["BottomRight"] = 15] = "BottomRight";
	})(Transparency = exports.Transparency || (exports.Transparency = {}));
	var PictureDeclaration = /** @class */ (function () {
	    function PictureDeclaration() {
	        /// Picture name.
	        this.name = '';
	        /// Picture type.
	        this.pictureType = PictureType.Normal;
	        /// Default distance, 1-999.
	        this.distance = 450;
	        /// Default clipping.
	        this.clipping = shared_1.Clip.Sky;
	        /// Transparency.
	        this.transparency = Transparency.TopLeft;
	    }
	    return PictureDeclaration;
	}());
	exports.default = PictureDeclaration;
	
} (PictureDeclaration));

var hasRequiredLgr;

function requireLgr () {
	if (hasRequiredLgr) return lgr;
	hasRequiredLgr = 1;
	(function (exports) {
		var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
		    return (mod && mod.__esModule) ? mod : { "default": mod };
		};
		Object.defineProperty(exports, "__esModule", { value: true });
		exports.Transparency = exports.PictureType = exports.PictureDeclaration = exports.PictureData = exports.LGR = void 0;
		var LGR_1 = requireLGR();
		Object.defineProperty(exports, "LGR", { enumerable: true, get: function () { return __importDefault(LGR_1).default; } });
		var PictureData_1 = PictureData$1;
		Object.defineProperty(exports, "PictureData", { enumerable: true, get: function () { return __importDefault(PictureData_1).default; } });
		var PictureDeclaration_1 = PictureDeclaration;
		Object.defineProperty(exports, "PictureDeclaration", { enumerable: true, get: function () { return __importDefault(PictureDeclaration_1).default; } });
		Object.defineProperty(exports, "PictureType", { enumerable: true, get: function () { return PictureDeclaration_1.PictureType; } });
		Object.defineProperty(exports, "Transparency", { enumerable: true, get: function () { return PictureDeclaration_1.Transparency; } });
		
} (lgr));
	return lgr;
}

var state = {};

var State = {};

(function (exports) {
	var __read = (commonjsGlobal && commonjsGlobal.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __spreadArray = (commonjsGlobal && commonjsGlobal.__spreadArray) || function (to, from) {
	    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
	        to[j] = from[i];
	    return to;
	};
	var __values = (commonjsGlobal && commonjsGlobal.__values) || function(o) {
	    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
	    if (m) return m.call(o);
	    if (o && typeof o.length === "number") return {
	        next: function () {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.VideoDetail = exports.SoundOptimization = exports.PlayMode = void 0;
	var buffer_1 = require$$0;
	var util_1 = util;
	var STATE_SIZE = 67910;
	var PLAYER_STRUCT_SIZE = 116;
	var PLAYERENTRY_PADDING = 38;
	var NUM_INTERNALS = 54;
	var PLAYER_NAME_SIZE = 15;
	var PLAYERENTRY_NAME_SIZE = 16;
	var LEVEL_NAME_SIZE = 20;
	var NUM_PLAYERS = 50;
	var NUM_LEVELS = 90;
	var STATE_START = 200;
	var STATE_END = 123432221;
	var STATE_END_ALT = 123432112;
	var PlayMode;
	(function (PlayMode) {
	    PlayMode[PlayMode["Single"] = 1] = "Single";
	    PlayMode[PlayMode["Multi"] = 0] = "Multi";
	})(PlayMode = exports.PlayMode || (exports.PlayMode = {}));
	var SoundOptimization;
	(function (SoundOptimization) {
	    SoundOptimization[SoundOptimization["Compatibility"] = 1] = "Compatibility";
	    SoundOptimization[SoundOptimization["BestQuality"] = 0] = "BestQuality";
	})(SoundOptimization = exports.SoundOptimization || (exports.SoundOptimization = {}));
	var VideoDetail;
	(function (VideoDetail) {
	    VideoDetail[VideoDetail["Low"] = 0] = "Low";
	    VideoDetail[VideoDetail["High"] = 1] = "High";
	})(VideoDetail = exports.VideoDetail || (exports.VideoDetail = {}));
	var State = /** @class */ (function () {
	    function State() {
	        // State file version; the only supported value is 200.
	        this.version = STATE_START;
	        // Best times lists. state.dat has a fixed-size array of 90 of these.
	        this.times = Array(90).fill({ single: [], multi: [] });
	        // List of players. state.dat has a fixed-size array of 50 of these.
	        this.players = [];
	        // Name of player A, maximum 14 characters.
	        this.playerAName = '';
	        // Name of player B, maximum 14 characters.
	        this.playerBName = '';
	        // Keys for player A.
	        this.playerAKeys = {
	            brake: 208,
	            changeDirection: 57,
	            rotateLeft: 203,
	            rotateRight: 205,
	            throttle: 200,
	            toggleNavigator: 47,
	            toggleShowHide: 2,
	            toggleTimer: 20,
	        };
	        // Keys for player B.
	        this.playerBKeys = {
	            brake: 80,
	            changeDirection: 82,
	            rotateLeft: 79,
	            rotateRight: 81,
	            throttle: 76,
	            toggleNavigator: 48,
	            toggleShowHide: 3,
	            toggleTimer: 21,
	        };
	        // Whether sound is enabled.
	        this.soundEnabled = true;
	        // Sound optimization.
	        this.soundOptimization = SoundOptimization.BestQuality;
	        // Play mode.
	        this.playMode = PlayMode.Single;
	        // Whether flag tag mode is enabled.
	        this.flagTag = false;
	        // Whether bikes are swapped.
	        this.swapBikes = false;
	        // Video detail.
	        this.videoDetail = VideoDetail.High;
	        // Whether objects are animated.
	        this.animatedObjects = true;
	        // Whether menus are animated.
	        this.animatedMenus = true;
	        // Key for increasing screen size.
	        this.incScreenSizeKey = 13;
	        // Key for decreasing screen size.
	        this.decScreenSizeKey = 12;
	        // Key for taking a screenshot.
	        this.screenshotKey = 23;
	        // Name of last edited level.
	        this.lastEditedLevName = '';
	        // Name of last played external level.
	        this.lastPlayedExternal = '';
	    }
	    /**
	     * Loads a state from a buffer representation of the file.
	     * @param buffer
	     */
	    State.from = function (buffer) {
	        if (buffer.length !== STATE_SIZE)
	            throw Error("Invalid state.dat file, expected buffer length of " + STATE_SIZE + ", got " + buffer.length);
	        return this.parseBuffer(buffer);
	    };
	    State.parseBuffer = function (buffer) {
	        var state = new State();
	        var decryptedBuffer = this.cryptState(buffer);
	        var offset = 0;
	        var version = decryptedBuffer.readUInt32LE(offset);
	        if (version !== STATE_START)
	            throw Error('Invalid state.dat file');
	        offset += 4;
	        for (var i = 0; i < NUM_LEVELS; i++) {
	            var levelTimesBuffer = decryptedBuffer.slice(offset, offset + 688);
	            var top10 = util_1.bufferToTop10(levelTimesBuffer);
	            state.times[i] = top10;
	            offset += 688;
	        }
	        // get amount of players before parsing player data
	        var players = decryptedBuffer.readUInt32LE(offset + 5800);
	        if (players > NUM_PLAYERS)
	            throw Error("Expected max " + NUM_PLAYERS + " player entries, got " + players);
	        for (var i = 0; i < players; i++) {
	            var nextPlayerOffset = offset + i * PLAYER_STRUCT_SIZE;
	            var player = this.parsePlayer(decryptedBuffer.slice(nextPlayerOffset, nextPlayerOffset + PLAYER_STRUCT_SIZE));
	            state.players.push(player);
	        }
	        offset += 5800 + 4;
	        state.playerAName = util_1.trimString(decryptedBuffer.slice(offset, offset + PLAYER_NAME_SIZE));
	        offset += PLAYER_NAME_SIZE;
	        state.playerBName = util_1.trimString(decryptedBuffer.slice(offset, offset + PLAYER_NAME_SIZE));
	        offset += PLAYER_NAME_SIZE;
	        // settings
	        state.soundEnabled = Boolean(decryptedBuffer.readInt32LE(offset));
	        offset += 4;
	        state.soundOptimization = decryptedBuffer.readInt32LE(offset);
	        offset += 4;
	        state.playMode = decryptedBuffer.readInt32LE(offset);
	        offset += 4;
	        state.flagTag = Boolean(decryptedBuffer.readInt32LE(offset));
	        offset += 4;
	        state.swapBikes = !Boolean(decryptedBuffer.readInt32LE(offset)); // inverted because Balazs 🤷‍♀️
	        offset += 4;
	        state.videoDetail = decryptedBuffer.readInt32LE(offset);
	        offset += 4;
	        state.animatedObjects = Boolean(decryptedBuffer.readInt32LE(offset));
	        offset += 4;
	        state.animatedMenus = Boolean(decryptedBuffer.readInt32LE(offset));
	        offset += 4;
	        state.playerAKeys = this.parsePlayerKeys(decryptedBuffer.slice(offset, offset + 32));
	        offset += 32;
	        state.playerBKeys = this.parsePlayerKeys(decryptedBuffer.slice(offset, offset + 32));
	        offset += 32;
	        state.incScreenSizeKey = decryptedBuffer.readUInt32LE(offset);
	        offset += 4;
	        state.decScreenSizeKey = decryptedBuffer.readUInt32LE(offset);
	        offset += 4;
	        state.screenshotKey = decryptedBuffer.readUInt32LE(offset);
	        offset += 4;
	        state.lastEditedLevName = util_1.trimString(decryptedBuffer.slice(offset, offset + LEVEL_NAME_SIZE));
	        offset += LEVEL_NAME_SIZE;
	        state.lastPlayedExternal = util_1.trimString(decryptedBuffer.slice(offset, offset + LEVEL_NAME_SIZE));
	        offset += LEVEL_NAME_SIZE;
	        // do we actually care about this?
	        var EOF = decryptedBuffer.readUInt32LE(offset);
	        if (!(EOF === STATE_END || EOF === STATE_END_ALT))
	            throw Error("Expected EOF marker, got " + EOF);
	        return state;
	    };
	    State.parsePlayer = function (buffer) {
	        if (buffer.length !== PLAYER_STRUCT_SIZE)
	            throw Error("Expected buffer of length " + PLAYER_STRUCT_SIZE + ", got " + buffer.length);
	        var name = util_1.trimString(buffer.slice(0, PLAYERENTRY_NAME_SIZE));
	        var skippedInternals = __spreadArray([], __read(buffer.slice(PLAYERENTRY_NAME_SIZE, PLAYERENTRY_NAME_SIZE + NUM_INTERNALS))).map(Boolean);
	        var lastInternal = buffer.readUInt32LE(PLAYERENTRY_NAME_SIZE + NUM_INTERNALS + PLAYERENTRY_PADDING);
	        var selectedInternal = buffer.readUInt32LE(PLAYERENTRY_NAME_SIZE + NUM_INTERNALS + PLAYERENTRY_PADDING + 4);
	        var player = { name: name, skippedInternals: skippedInternals, lastInternal: lastInternal, selectedInternal: selectedInternal };
	        return player;
	    };
	    State.parsePlayerKeys = function (buffer) {
	        if (buffer.length !== 32)
	            throw Error("Expected buffer of length 32, got " + buffer.length);
	        var offset = 0;
	        var throttle = buffer.readUInt32LE(offset);
	        offset += 4;
	        var brake = buffer.readUInt32LE(offset);
	        offset += 4;
	        var rotateRight = buffer.readUInt32LE(offset);
	        offset += 4;
	        var rotateLeft = buffer.readUInt32LE(offset);
	        offset += 4;
	        var changeDirection = buffer.readUInt32LE(offset);
	        offset += 4;
	        var toggleNavigator = buffer.readUInt32LE(offset);
	        offset += 4;
	        var toggleTimer = buffer.readUInt32LE(offset);
	        offset += 4;
	        var toggleShowHide = buffer.readUInt32LE(offset);
	        return {
	            throttle: throttle,
	            brake: brake,
	            rotateRight: rotateRight,
	            rotateLeft: rotateLeft,
	            changeDirection: changeDirection,
	            toggleNavigator: toggleNavigator,
	            toggleTimer: toggleTimer,
	            toggleShowHide: toggleShowHide,
	        };
	    };
	    State.cryptState = function (buffer) {
	        var e_1, _a;
	        var bufCopy = buffer_1.Buffer.from(buffer);
	        var statePieces = [
	            4,
	            61920,
	            5800,
	            4,
	            PLAYER_NAME_SIZE,
	            PLAYER_NAME_SIZE,
	            4,
	            4,
	            4,
	            4,
	            4,
	            4,
	            4,
	            4,
	            32,
	            32,
	            4,
	            4,
	            4,
	            LEVEL_NAME_SIZE,
	            LEVEL_NAME_SIZE,
	        ];
	        var curr = 0;
	        try {
	            for (var statePieces_1 = __values(statePieces), statePieces_1_1 = statePieces_1.next(); !statePieces_1_1.done; statePieces_1_1 = statePieces_1.next()) {
	                var p = statePieces_1_1.value;
	                var decryptedPart = this.cryptStatePiece(bufCopy.slice(curr, curr + p));
	                decryptedPart.copy(bufCopy, curr);
	                curr += p;
	            }
	        }
	        catch (e_1_1) { e_1 = { error: e_1_1 }; }
	        finally {
	            try {
	                if (statePieces_1_1 && !statePieces_1_1.done && (_a = statePieces_1.return)) _a.call(statePieces_1);
	            }
	            finally { if (e_1) throw e_1.error; }
	        }
	        return bufCopy;
	    };
	    State.cryptStatePiece = function (buffer) {
	        var bufCopy = buffer_1.Buffer.from(buffer);
	        var ebp8 = 0x17;
	        var ebp10 = 0x2636;
	        for (var i = 0; i < buffer.length; i++) {
	            bufCopy[i] ^= ebp8 & 0xff;
	            ebp10 += (ebp8 % 0xd3f) * 0xd3f;
	            ebp8 = ebp10 * 0x1f + 0xd3f;
	            ebp8 = (ebp8 & 0xffff) - 2 * (ebp8 & 0x8000);
	        }
	        return bufCopy;
	    };
	    /**
	     * Returns a buffer representation of the State.
	     */
	    State.prototype.toBuffer = function () {
	        var e_2, _a, e_3, _b;
	        var buffer = buffer_1.Buffer.alloc(STATE_SIZE);
	        var offset = 0;
	        buffer.writeUInt32LE(STATE_START);
	        offset += 4;
	        try {
	            for (var _c = __values(this.times.slice(0, NUM_LEVELS)), _d = _c.next(); !_d.done; _d = _c.next()) {
	                var top10 = _d.value;
	                var top10Buffer = util_1.top10ToBuffer(top10);
	                top10Buffer.copy(buffer, offset);
	                offset += 688;
	            }
	        }
	        catch (e_2_1) { e_2 = { error: e_2_1 }; }
	        finally {
	            try {
	                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
	            }
	            finally { if (e_2) throw e_2.error; }
	        }
	        // "reset" offset, essentially handling there being less top10s than NUM_LEVELS
	        // as the buffer is already 0-filled
	        offset = 4 + 61920;
	        try {
	            for (var _e = __values(this.players.slice(0, NUM_PLAYERS)), _f = _e.next(); !_f.done; _f = _e.next()) {
	                var player = _f.value;
	                var name = util_1.nullpadString(player.name, PLAYERENTRY_NAME_SIZE);
	                buffer.write(name, offset, PLAYERENTRY_NAME_SIZE, 'ascii');
	                offset += PLAYERENTRY_NAME_SIZE;
	                var skippedInternals = player.skippedInternals.slice(0, NUM_INTERNALS);
	                skippedInternals.forEach(function (skipped) {
	                    buffer.writeUInt8(skipped ? 1 : 0, offset);
	                    offset += 1;
	                });
	                if (skippedInternals.length < NUM_INTERNALS) {
	                    offset += NUM_INTERNALS - skippedInternals.length;
	                }
	                offset += PLAYERENTRY_PADDING;
	                buffer.writeInt32LE(player.lastInternal, offset);
	                offset += 4;
	                buffer.writeInt32LE(player.selectedInternal, offset);
	                offset += 4;
	            }
	        }
	        catch (e_3_1) { e_3 = { error: e_3_1 }; }
	        finally {
	            try {
	                if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
	            }
	            finally { if (e_3) throw e_3.error; }
	        }
	        if (this.players.length < NUM_PLAYERS) {
	            buffer.fill(0, offset, offset + PLAYER_STRUCT_SIZE * (NUM_PLAYERS - this.players.length));
	            offset += PLAYER_STRUCT_SIZE * (NUM_PLAYERS - this.players.length);
	        }
	        buffer.writeUInt32LE(this.players.length, offset);
	        offset += 4;
	        buffer.write(util_1.nullpadString(this.playerAName, PLAYER_NAME_SIZE), offset, PLAYER_NAME_SIZE, 'ascii');
	        offset += PLAYER_NAME_SIZE;
	        buffer.write(util_1.nullpadString(this.playerBName, PLAYER_NAME_SIZE), offset, PLAYER_NAME_SIZE, 'ascii');
	        offset += PLAYER_NAME_SIZE;
	        // settings
	        buffer.writeInt32LE(this.soundEnabled ? 1 : 0, offset);
	        offset += 4;
	        buffer.writeInt32LE(this.soundOptimization, offset);
	        offset += 4;
	        buffer.writeInt32LE(this.playMode, offset);
	        offset += 4;
	        buffer.writeInt32LE(this.flagTag ? 1 : 0, offset);
	        offset += 4;
	        buffer.writeInt32LE(this.swapBikes ? 0 : 1, offset);
	        offset += 4;
	        buffer.writeInt32LE(this.videoDetail, offset);
	        offset += 4;
	        buffer.writeInt32LE(this.animatedObjects ? 1 : 0, offset);
	        offset += 4;
	        buffer.writeInt32LE(this.animatedMenus ? 1 : 0, offset);
	        offset += 4;
	        // keys
	        [this.playerAKeys, this.playerBKeys].forEach(function (keys) {
	            buffer.writeUInt32LE(keys.throttle, offset);
	            offset += 4;
	            buffer.writeUInt32LE(keys.brake, offset);
	            offset += 4;
	            buffer.writeUInt32LE(keys.rotateRight, offset);
	            offset += 4;
	            buffer.writeUInt32LE(keys.rotateLeft, offset);
	            offset += 4;
	            buffer.writeUInt32LE(keys.changeDirection, offset);
	            offset += 4;
	            buffer.writeUInt32LE(keys.toggleNavigator, offset);
	            offset += 4;
	            buffer.writeUInt32LE(keys.toggleTimer, offset);
	            offset += 4;
	            buffer.writeUInt32LE(keys.toggleShowHide, offset);
	            offset += 4;
	        });
	        buffer.writeUInt32LE(this.incScreenSizeKey, offset);
	        offset += 4;
	        buffer.writeUInt32LE(this.decScreenSizeKey, offset);
	        offset += 4;
	        buffer.writeUInt32LE(this.screenshotKey, offset);
	        offset += 4;
	        buffer.write(util_1.nullpadString(this.lastEditedLevName, LEVEL_NAME_SIZE), offset, LEVEL_NAME_SIZE, 'ascii');
	        offset += LEVEL_NAME_SIZE;
	        buffer.write(util_1.nullpadString(this.lastPlayedExternal, LEVEL_NAME_SIZE), offset, LEVEL_NAME_SIZE, 'ascii');
	        offset += LEVEL_NAME_SIZE;
	        buffer.writeUInt32LE(STATE_END, offset);
	        return State.cryptState(buffer);
	    };
	    return State;
	}());
	exports.default = State;
	
} (State));

(function (exports) {
	var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.SoundOptimization = exports.VideoDetail = exports.PlayMode = exports.State = void 0;
	var State_1 = State;
	Object.defineProperty(exports, "State", { enumerable: true, get: function () { return __importDefault(State_1).default; } });
	Object.defineProperty(exports, "PlayMode", { enumerable: true, get: function () { return State_1.PlayMode; } });
	Object.defineProperty(exports, "VideoDetail", { enumerable: true, get: function () { return State_1.VideoDetail; } });
	Object.defineProperty(exports, "SoundOptimization", { enumerable: true, get: function () { return State_1.SoundOptimization; } });
	
} (state));

var hasRequiredLib;

function requireLib () {
	if (hasRequiredLib) return lib;
	hasRequiredLib = 1;
	(function (exports) {
		var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
		}) : (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    o[k2] = m[k];
		}));
		var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
		    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
		};
		Object.defineProperty(exports, "__esModule", { value: true });
		__exportStar(requireLev(), exports);
		__exportStar(requireRec(), exports);
		__exportStar(shared, exports);
		__exportStar(util, exports);
		__exportStar(requireLgr(), exports);
		__exportStar(state, exports);
		
} (lib));
	return lib;
}

var libExports = requireLib();

/**
 * Reduced subset of the implementation of PCX files as they are supported by Across and Elma
 * Only version 3.0, 8bpp, single bitplane PCX files are supported by these programs
 * The bitmap and palette are separated into two functions as often the palette comes from a different pcx file
 * When colorizing an image, you can specify the transparency as in Elma LGRs
 */
/**
 * Enum for transparency as used by LGR files
 *  - Solid: No transparency
 *  - Palette: Palette id 0 is transparent
 *  - TopLeft/TopRight/BottomLeft/BottomRight: selected pixel's palette id is transparent
 * @readonly
 */
var Transparency;
(function (Transparency) {
    Transparency[Transparency["Solid"] = 10] = "Solid";
    Transparency[Transparency["Palette"] = 11] = "Palette";
    Transparency[Transparency["TopLeft"] = 12] = "TopLeft";
    Transparency[Transparency["TopRight"] = 13] = "TopRight";
    Transparency[Transparency["BottomLeft"] = 14] = "BottomLeft";
    Transparency[Transparency["BottomRight"] = 15] = "BottomRight";
})(Transparency || (Transparency = {}));
class PCX {
    buffer;
    byteView;
    header;
    width;
    height;
    _pixels;
    /**
     *
     * @param {Uint8Array | Buffer} buffer - raw file buffer
     */
    constructor(buffer) {
        this.buffer = buffer;
        this.byteView = new Uint8Array(buffer);
        if (this.byteView[0] !== 0x0a) {
            throw new Error('Invalid PCX file');
        }
        this.header = {
            version: this.byteView[1],
            encoding: this.byteView[2],
            bpp: this.byteView[3],
            xmin: this._readLEWord(4),
            ymin: this._readLEWord(6),
            xmax: this._readLEWord(8),
            ymax: this._readLEWord(10),
            bitplanes: this.byteView[65],
            bpr: this._readLEWord(66),
        };
        if (this.header.version !== 5) {
            throw new Error('Only Version 3.0 PCX files are supported');
        }
        if (this.header.encoding !== 1) {
            throw new Error('Invalid PCX encoding');
        }
        if (this.header.bpp !== 8) {
            throw new Error('Only 8bpp PCX files are supported');
        }
        if (this.header.bitplanes !== 1) {
            throw new Error('Only single bitplane PCX files are supported (Extended VGA)');
        }
        this.width = this.header.xmax - this.header.xmin + 1;
        this.height = this.header.ymax - this.header.ymin + 1;
        this._pixels = null;
    }
    /**
     * Reads a 16-bit uint from the data buffer
     * @param {number} - byte offset of the raw data
     * @returns {number} 16-bit uint
     */
    _readLEWord(offset) {
        return this.byteView[offset] | (this.byteView[offset + 1] << 8);
    }
    /**
     * Gets the RGB palette data from the file
     * @returns {Uint8Array} Palette of length 768
     */
    getPalette() {
        if (this.byteView[this.buffer.byteLength - 769] !== 12) {
            throw new Error('Palette not found!');
        }
        return this.byteView.slice(this.buffer.byteLength - 768);
    }
    /**
     * Gets the file's bitmap pixel data
     * @returns {Uint8Array} Flattened pixel array of size width*height
     */
    getPixels() {
        if (!this._pixels) {
            this._pixels = this._decompressPCXData();
        }
        return this._pixels;
    }
    /**
     * Decompresses the raw data from the file to get the bitmap pixel data
     * @returns {Uint8Array} Flattened bitmap pixel data
     */
    _decompressPCXData() {
        const pixels = new Uint8Array(this.width * this.height);
        let offset = 128;
        for (let i = 0; i < this.height; i++) {
            let j = 0;
            while (j < this.header.bpr) {
                const byte1 = this.byteView[offset];
                offset++;
                let length = 1;
                let value = byte1;
                if ((byte1 & 0b11000000) == 0b11000000) {
                    length = byte1 & 0b00111111;
                    value = this.byteView[offset];
                    offset++;
                }
                for (let x = 0; x < length; x++) {
                    // skip buffer pixels
                    if (j < this.width) {
                        pixels[i * this.width + j] = value;
                    }
                    j++;
                }
            }
            if (this.header.bpr !== j) {
                throw new Error('PCX images must have a decoding break at the end of each scanline');
            }
        }
        return pixels;
    }
    /**
     * Calculates which palette id is transparent
     * @param {Transparency} transparency - An enum value from Transparency
     * @returns {number} The palette id that should be transparent
     */
    _getTransparencyPaletteId(transparency) {
        switch (transparency) {
            case Transparency.Solid:
                return -1;
            case Transparency.Palette:
                return 0;
            case Transparency.TopLeft:
                return this.getPixels()[0];
            case Transparency.TopRight:
                return this.getPixels()[this.width - 1];
            case Transparency.BottomLeft:
                return this.getPixels()[this.height * (this.width - 1)];
            case Transparency.BottomRight:
                return this.getPixels()[this.height * this.width - 1];
        }
    }
    /**
     * Colorizes the bitmap with the provided palette, given a transparent palette id
     * @param {Uint8Array} palette - A palette from getPalette()
     * @param {number} transparentPaletteId - A palette id from _getTransparencyPaletteId()
     * @returns {Uint8Array} Flattened RGBA pixel array of size 4*width*height
     */
    _colorize(palette, transparentPaletteId) {
        const colorPixels = new Uint8ClampedArray(this.width * this.height * 4);
        const pixels = this.getPixels();
        const size = this.width * this.height;
        for (let i = 0; i < size; i++) {
            const paletteId = pixels[i];
            const paletteOffset = 3 * paletteId;
            const colorOffset = 4 * i;
            colorPixels[colorOffset] = palette[paletteOffset];
            colorPixels[colorOffset + 1] = palette[paletteOffset + 1];
            colorPixels[colorOffset + 2] = palette[paletteOffset + 2];
            if (paletteId === transparentPaletteId) {
                colorPixels[colorOffset + 3] = 0;
            }
            else {
                colorPixels[colorOffset + 3] = 255;
            }
        }
        return colorPixels;
    }
    /**
     * Returns a colorized image from the image's pixels, using the provided palette and transparency options.
     * The image can be converted in the browser as follows:
     * @example
     * const imageData = new ImageData(pcxFile.getImage(), pcxFile.width, pcxFile.height)
     * const imageBitmap = await createImageBitmap(imageData)
     * @param {Uint8Array} palette - A palette from getPalette()
     * @param {Transparency} transparency - A transparency option from Transparency
     * @returns {Uint8Array} Flattened RGBA pixel array of size 4*width*height
     */
    getImage(palette, transparency) {
        const transparentPaletteId = this._getTransparencyPaletteId(transparency);
        const colorData = this._colorize(palette, transparentPaletteId);
        return colorData;
    }
}

const legacy_imgs = [
  "bike",
  //"ground",
  "head",
  //"sky",
  "susp1",
  "susp2",
  "wheel",
  "qfood1",
  "qfood2",
  "qkiller",
  "qexit",
  "q1body",
  "q1forarm",
  "q1leg",
  "q1thigh",
  "q1up_arm",
  //"myshirt",
];
const legacy_picts = [
  ["qgrass", "text", 400, "s"],
  ["qdown_1", "pict", 400, "s"],
  ["qdown_14", "pict", 400, "s"],
  ["qdown_5", "pict", 400, "s"],
  ["qdown_9", "pict", 400, "s"],
  ["qup_0", "pict", 400, "s"],
  ["qup_1", "pict", 400, "s"],
  ["qup_14", "pict", 400, "s"],
  ["qup_5", "pict", 400, "s"],
  ["qup_9", "pict", 400, "s"],
  ["qup_18", "pict", 400, "s"],
  ["qdown_18", "pict", 400, "s"],
  ["cliff", "pict", 400, "s"],
  ["stone1", "text", 750, "g"],
  ["stone2", "text", 750, "g"],
  ["stone3", "text", 750, "s"],
  ["st3top", "pict", 740, "s"],
  ["brick", "text", 750, "g"],
  //["qfood1", "pict", 400, "u"],
  //["qfood2", "pict", 400, "u"],
  ["bridge", "pict", 400, "u"],
  ["sky", "text", 800, "s"],
  ["tree2", "pict", 540, "s"],
  ["bush3", "pict", 440, "s"],
  ["tree4", "pict", 600, "s"],
  ["tree5", "pict", 600, "s"],
  ["log2", "pict", 420, "s"],
  ["sedge", "pict", 430, "s"],
  ["tree3", "pict", 560, "s"],
  ["plantain", "pict", 450, "u"],
  ["bush1", "pict", 550, "s"],
  ["bush2", "pict", 550, "s"],
  ["ground", "text", 800, "g"],
  ["flag", "pict", 450, "s"],
  ["secret", "pict", 550, "s"],
  ["hang", "pict", 434, "s"],
  ["edge", "pict", 440, "u"],
  ["mushroom", "pict", 430, "s"],
  ["log1", "pict", 420, "s"],
  ["tree1", "pict", 550, "s"],
  ["maskbig", "mask", null, ""],
  ["maskhor", "mask", null, ""],
  ["masklitt", "mask", null, ""],
  ["barrel", "pict", 380, "s"],
  ["supphred", "pict", 380, "s"],
  ["suppvred", "pict", 380, "s"],
  ["support2", "pict", 380, "u"],
  ["support3", "pict", 380, "u"],
  ["support1", "pict", 380, "u"],
  ["suspdown", "pict", 380, "u"],
  ["suspup", "pict", 380, "u"],
  ["susp", "pict", 380, "u"],
];

class LGRImage {
  constructor(lgr, name) {
    this.lgr = lgr;
    this.name = name;
    this.imageLoading = false;
    this.image = null;
    this.imageData = null;
    this.borders = null;
    this.width = null;
    this.height = null;
  }

  loadImage() {
    throw Error("Not implemented");
  }

  getImage() {
    if (this.image) {
      return this.image;
    }
    if (!this.imageLoading) {
      this.imageLoading = true;
      this.loadImage();
    }
    return false;
  }

  imageLoaded() {
    this.updateGrass();
    this.lgr.updated();
  }

  updateGrass() {
    if (this.isGrassUp()) {
      this.lgr.grassUp.push(this);
      this.calculateHeightmap();
    }
    if (this.isGrassDown()) {
      this.lgr.grassDown.push(this);
      this.calculateHeightmap();
    }
  }

  calculateHeightmap() {
    if (!this.imageData) {
      this.legacy_calculateHeightmap();
      return;
    }
    const { data, width, height } = this.imageData;
    const heightmap = [];
    for (let j = 0; j < width; j++) {
      let i;
      for (i = 0; i < height && data[4 * (i * width + j) + 3] === 0; i++);
      heightmap.push(i);
    }
    this.borders = heightmap;
  }

  legacy_calculateHeightmap() {
    const heightmap = [];
    const up = this.isGrassUp();
    const diff = this.height - 41;
    const from = this.height / 2 + ((up ? 1 : -1) * diff) / 2;
    const to = this.height / 2 + ((up ? -1 : 1) * diff) / 2;
    for (let x = 0; x < this.width; x++) {
      heightmap.push(from + (to - from) * (x / this.width));
    }
    this.borders = heightmap;
  }

  isGrassUp() {
    return this.name.startsWith("qup_");
  }

  isGrassDown() {
    return this.name.startsWith("qdown_");
  }

  static placeholder_image(canv) {
    canv.save();
    canv.lineWidth = 1 / 20;
    canv.strokeStyle = "red";
    canv.beginPath();
    canv.moveTo(0.5, 0);
    canv.lineTo(0.5, 1);
    canv.moveTo(0, 0.5);
    canv.lineTo(1, 0.5);
    canv.arc(0.5, 0.5, 0.5, 0, Math.PI * 2);
    canv.stroke();
    canv.restore();
  }

  static placeholder_texture(canv, w, h) {
    canv.save();
    canv.fillStyle = "blue";
    canv.fillRect(0, 0, w, h);
    canv.beginPath();
    canv.strokeStyle = "white";
    for (let x = 0; x <= w; x += 20) {
      canv.moveTo(x, 0);
      canv.lineTo(x, h);
    }
    for (let y = 0; y <= h; y += 20) {
      canv.moveTo(0, y);
      canv.lineTo(w, y);
    }
    canv.stroke();
    canv.restore();
  }

  static placeholder_object(canv, frame) {
    canv.save();
    canv.translate(0.5, 0.5);
    canv.rotate((Math.PI * 2 * frame) / 50);
    canv.translate(-0.5, -0.5);
    this.placeholder_image(canv);
    canv.restore();
  }

  draw(canv) {
    const image = this.getImage();
    if (image) {
      canv.drawImage(image, 0, 0, 1, 1);
    } else {
      this.constructor.placeholder_image(canv);
    }
  }

  drawAt(canv) {
    const image = this.getImage();
    if (image) {
      canv.drawImage(image, 0, 0);
    } else {
      canv.save();
      canv.scale(48, 48);
      this.constructor.placeholder_image(canv);
      canv.restore();
    }
  }

  repeat(canv, w, h) {
    const image = this.getImage();
    if (image) {
      canv.fillStyle = canv.createPattern(image, "repeat");
      canv.fillRect(0, 0, w, h);
    } else {
      this.constructor.placeholder_texture(canv, w, h);
    }
  }

  static arrow(gravity) {
    switch (gravity) {
      case 1:
        return "\u2191";
      case 2:
        return "\u2193";
      case 3:
        return "\u2190";
      case 4:
        return "\u2192";
      default:
        return "";
    }
  }

  frame(canv, frame, gravity, showGravityArrows) {
    const image = this.getImage();
    if (image) {
      frame = Math.floor(frame);
      const totalFrames = Math.floor(image.width / 40);
      canv.drawImage(
        image,
        (frame % totalFrames) * 40,
        0,
        40,
        image.height,
        0,
        0,
        1,
        1
      );
      if (gravity && showGravityArrows) {
        canv.font = "1px Courier";
        canv.fillText(this.constructor.arrow(gravity), 0.2, 0.8);
      }
    } else {
      this.constructor.placeholder_object(canv, frame);
    }
  }
}

class UrlImage extends LGRImage {
  constructor(lgr, name, url) {
    super(lgr, name);
    this.url = url;
    // Placeholder values
    this.width = 48;
    this.height = 48;
  }

  loadImage() {
    const _image = document.createElement("img");
    _image.src = this.url;
    _image.onload = () => {
      this.width = _image.width;
      this.height = _image.height;
      this.image = _image;
      this.imageLoaded();
    };
  }
}

class PCXImage extends LGRImage {
  constructor(lgr, name, pcxData) {
    super(lgr, name);
    this.palette = lgr.palette;
    this.pcx = new PCX(pcxData);
    this.width = this.pcx.width;
    this.height = this.pcx.height;
  }

  getTransparency() {
    const pictureList = this.lgr.pictureList[this.name];
    let transparency = pictureList?.transparency || libExports.Transparency.TopLeft;
    if (pictureList?.pictureType === libExports.PictureType.Texture) {
      transparency = libExports.Transparency.Solid;
    }
    if (this.name === "qgrass") {
      transparency = libExports.Transparency.Solid;
    }
    if (
      this.isGrassUp() ||
      this.isGrassDown() ||
      this.name.startsWith("qfood")
    ) {
      transparency = libExports.Transparency.TopLeft;
    }
    return transparency;
  }

  loadImage() {
    const colorData = this.pcx.getImage(
      this.lgr.palette,
      this.getTransparency()
    );
    this.imageData = new ImageData(colorData, this.width, this.height, {});
    createImageBitmap(this.imageData).then((imageBitmap) => {
      this.image = imageBitmap;
      this.imageLoaded();
    });
  }
}

class LGRWrapper {
  constructor(lgrFile, legacy_path) {
    this._ident = {};
    this.playerInvalidate = function () {}; // callback function for player.js
    this.picts = {};
    this.grassUp = [];
    this.grassDown = [];

    if (!lgrFile) {
      this.legacy_loadLgr(legacy_path);
    } else {
      this.loadLgr(lgrFile);
    }
  }

  legacy_loadLgr(legacy_path) {
    legacy_imgs.forEach((imageName) => {
      this.addImageFromUrl(imageName, `${legacy_path}/${imageName}.png`);
    });
    legacy_picts.forEach((image) => {
      this.addImageFromUrl(image[0], `${legacy_path}/picts/${image[0]}.png`);
    });
    this.assignFood();
    // legacy images with non-standard names
    this.picts.q1bike = this.picts.bike;
    this.picts.q1wheel = this.picts.wheel;
    this.picts.q1head = this.picts.head;
    this.picts.q1susp1 = this.picts.susp1;
    this.picts.q1susp2 = this.picts.susp2;
  }

  loadLgr(lgrFile) {
    const lgr = libExports.LGR.from(lgrFile);
    this.pictureList = lgr.pictureList.reduce((obj, val) => {
      obj[val.name.toLowerCase()] = val;
      return obj;
    }, {});
    const q1bike = new PCX(
      lgr.pictureData.find(
        (picture) => picture.name.toLowerCase() === "q1bike.pcx"
      ).data
    );
    this.palette = q1bike.getPalette();
    lgr.pictureData.forEach((pictureDatum) => {
      const name = pictureDatum.name
        .toLowerCase()
        .slice(0, pictureDatum.name.length - 4);
      this.addImageFromPcx(name, pictureDatum.data);
    });
    this.assignFood();
  }

  addImageFromUrl(name, url) {
    return this._addImage(name, new UrlImage(this, name, url));
  }

  addImageFromPcx(name, pcxData) {
    return this._addImage(name, new PCXImage(this, name, pcxData));
  }

  _addImage(name, image) {
    this.picts[name] = image;
    if (image.isGrassUp() || image.isGrassDown()) {
      image.getImage();
    }
    return image;
  }

  assignFood() {
    // Define images for the unused animation objects
    let i = 1;
    while (i < 10) {
      if (!this.picts[`qfood${i}`]) {
        break;
      }
      i++;
    }
    let j = 1;
    while (i < 10) {
      this.picts[`qfood${i}`] = this.picts[`qfood${j}`];
      i++;
      j++;
    }
  }

  updated() {
    this._ident = {};
    this.playerInvalidate();
  }
}

function rectsOverlap(x1, y1, w1, h1, x2, y2, w2, h2) {
  return (
    // parentheses required! ASI!
    x1 + w1 >= x2 && y1 + h1 >= y2 && x2 + w2 >= x1 && y2 + h2 >= y1
  );
}

var geom = {
  rectsOverlap: rectsOverlap
};

// an append-only quad tree

function sum(names) {
  var o = {};
  names.forEach(function(name) {
    o[name] = function() {
      var a = [].slice.call(arguments);
      return function(ops) {
        return ops[name].apply(undefined, a);
      };
    };
  });
  return o;
}

var Tree = sum(["nil", "tip", "branch"]);
var nil = Tree.nil();

function quadTree(minW) {
  // root must be a (quad) branch
  var root = Tree.branch([nil, nil, nil, nil]);
  var rootW = 1; // length of top-level squares, all touching (0,0)

  function add(valx, valy, val) {
    root({
      branch: function(quads) {
        while (Math.abs(valx) >= rootW || Math.abs(valy) >= rootW) {
          quads[0] = Tree.branch([nil, nil, nil, quads[0]]);
          quads[1] = Tree.branch([nil, nil, quads[1], nil]);
          quads[2] = Tree.branch([nil, quads[2], nil, nil]);
          quads[3] = Tree.branch([quads[3], nil, nil, nil]);
          rootW *= 2;
        }
      }
    });
    if (add_({ x: valx, y: valy, val: val }, root, 0, 0, rootW) !== root)
      throw new Error(
        "internal error: a gyökér csomópontoknak egyezniük kell!"
      ); // hehe
  }

  function add_(desc, tree, x, y, w) {
    return tree({
      nil: function() {
        return Tree.tip([desc]);
      },

      tip: function(descs) {
        if (w < minW) {
          descs.push(desc);
          return tree;
        }
        var r = Tree.branch([nil, nil, nil, nil]);
        for (var z = 0; z < descs.length; z++) r = add_(descs[z], r, x, y, w);
        return add_(desc, r, x, y, w);
      },

      branch: function(quads) {
        var dx = desc.x < x ? -1 : 1;
        var dy = desc.y < y ? -1 : 1;
        var quad = 2 * (dy < 0 ? 0 : 1) + (dx < 0 ? 0 : 1);
        quads[quad] = add_(
          desc,
          quads[quad],
          x + dx * w / 2,
          y + dy * w / 2,
          w / 2
        );
        return tree;
      }
    });
  }

  // assuming w and h are positive
  function traverse(x, y, w, h, fn) {
    traverse_(root, 0, 0, rootW, x, y, w, h, function(desc) {
      if (desc.x >= x && desc.y >= y && desc.x < x + w && desc.y < y + h)
        fn(desc.x, desc.y, desc.val);
    });
  }

  function traverse_(tree, tx, ty, tw, x, y, w, h, fn) {
    tree({
      nil: function() {},

      tip: function(descs) {
        descs.forEach(fn);
      },

      branch: function(quads) {
        var n = 0;
        for (var sy = 0; sy < 2; sy++)
          for (var sx = 0; sx < 2; sx++) {
            var dx = sx == 0 ? -1 : 1;
            var dy = sy == 0 ? -1 : 1;
            if (
              geom.rectsOverlap(
                x,
                y,
                w,
                h,
                tx - tw + sx * tw,
                ty - tw + sy * tw,
                tw,
                tw
              )
            )
              traverse_(
                quads[n],
                tx + dx * tw / 2,
                ty + dy * tw / 2,
                tw / 2,
                x,
                y,
                w,
                h,
                fn
              );
            n++;
          }
      }
    });
  }

  function dbgdraw(canv, x, y, w, h) {
    dbgdraw_(canv, root, 0, 0, rootW, x, y, w, h);
  }

  function dbgdraw_(canv, tree, tx, ty, tw, x, y, w, h) {
    if (!geom.rectsOverlap(x, y, w, h, tx - tw, ty - tw, tw * 2, tw * 2))
      return;
    canv.strokeRect(tx - tw, ty - tw, tw * 2, tw * 2);

    function nvm() {}
    tree({
      nil: nvm,
      tip: nvm,

      branch: function(quads) {
        var n = 0;
        for (var sy = 0; sy < 2; sy++)
          for (var sx = 0; sx < 2; sx++) {
            var dx = sx == 0 ? -1 : 1;
            var dy = sy == 0 ? -1 : 1;
            dbgdraw_(
              canv,
              quads[n++],
              tx + dx * tw / 2,
              ty + dy * tw / 2,
              tw / 2,
              x,
              y,
              w,
              h
            );
          }
      }
    });
  }

  return {
    add: add,
    traverse: traverse,
    dbgdraw: dbgdraw
  };
}

function levRender(reader, lgr) {
  var polyTree = [];
  var grassPolys = [];

  function isSub(v, outer) {
    function hits(a, b) {
      // does the line [x, y]–[x, inf] intersect the line a–b?
      var left = Math.min(a[0], b[0]),
        right = Math.max(a[0], b[0]);
      if (v[0] < left || v[0] >= right) return false;
      var m = (b[1] - a[1]) / (b[0] - a[0]);
      var yint = m * (v[0] - a[0]) + a[1];
      return yint > v[1];
    }

    var n = 0;
    for (var z = 0; z < outer.length; z++)
      if (hits(outer[z], outer[(z + 1) % outer.length])) n++;
    return n % 2 != 0;
  }

  function addPoly(vertices, tree) {
    var newTree = [];
    for (var x = 0; x < tree.length; x++) {
      if (isSub(vertices[0], tree[x].vertices)) {
        return addPoly(vertices, tree[x].inner);
      }
      if (isSub(tree[x].vertices[0], vertices)) {
        newTree.push(tree[x]);
        if (x + 1 == tree.length) tree.pop();
        else tree[x] = tree.pop();
        x--;
      }
    }
    return (tree[x] = { vertices: vertices, inner: newTree });
  }

  function traverse(tree, isSolid, fn) {
    tree.forEach(function(poly) {
      fn(isSolid, poly.vertices);
      traverse(poly.inner, !isSolid, fn);
    });
  }

  var minX = Infinity,
    minY = Infinity;
  var maxX = -Infinity,
    maxY = -Infinity;

  reader.polyReader(function(grass, count, vertices) {
    var poly = [];
    vertices(function(x, y) {
      minX = Math.min(minX, x);
      minY = Math.min(minY, y);
      maxX = Math.max(maxX, x);
      maxY = Math.max(maxY, y);
      poly.push([x, y]);
    });
    if (grass) grassPolys.push(poly);
    else addPoly(poly, polyTree);
  });

  var pictures = (function() {
    var tree;
    var maxImgW, maxImgH; // for overbounding in .traverse

    function traverse(x, y, w, h, fn) {
      tree.traverse(x - maxImgW, y - maxImgH, w + maxImgW, h + maxImgH, fn);
    }

    function calc() {
      tree = quadTree(1);
      maxImgW = maxImgH = 0;

      var count = reader.picCount();
      for (var x = 0; x < count; x++) {
        var pic = reader.pic_(x);
        pic.num = x;
        // TODO: defaults?
        tree.add(pic.x, pic.y, pic);
        [pic.picture, pic.mask, pic.texture].forEach(function(picname) {
          var img = lgr.picts[picname];
          if (img && img.width !== undefined && img.height !== undefined) {
            img.getImage();
            maxImgW = Math.max(maxImgW, img.width / 48);
            maxImgH = Math.max(maxImgH, img.height / 48);
          }
        });
      }
    }

    return {
      calc: calc,
      traverse: traverse,
      dbgdraw: function(canv, x, y, w, h) {
        tree.dbgdraw(canv, x, y, w, h);
      }
    };
  })();

  var grass = (function() {
    var tree;
    var maxImgW, maxImgH; // for overbounding in .traverse

    // assuming w and h are positive
    function traverse(x, y, w, h, fn) {
      tree.traverse(x - maxImgW, y - maxImgH, w + maxImgW, h + maxImgH, fn);
    }

    function calc() {
      tree = quadTree(1);
      maxImgW = maxImgH = 0;

      grassPolys.forEach(function(p) {
        calcGrassPoly(48, p);
      });

      function calcGrassPoly(scale, poly) {
        // the path selection is demonstrably wrong, but it probably works in all reasonable cases.
        // it draws along the path from the left-most vertex to the right-most vertex that doesn't
        //   include the widest edge.
        // haven't figured out exactly what Elma itself does.
        var minX = Infinity,
          maxX = -Infinity,
          minXi,
          maxXi;
        for (var z = 0; z < poly.length; z++) {
          // WARNING: funny code
          if (minX != (minX = Math.min(minX, poly[z][0]))) minXi = z;
          if (maxX != (maxX = Math.max(maxX, poly[z][0]))) maxXi = z;
        }
        var maxW = 0;
        for (var z = minXi; z % poly.length != maxXi; z++)
          maxW = Math.max(
            maxW,
            Math.abs(poly[z % poly.length][0] - poly[(z + 1) % poly.length][0])
          );
        var dir = -1;
        for (var z = poly.length + minXi; z % poly.length != maxXi; z--)
          if (
            maxW !=
            (maxW = Math.max(
              maxW,
              Math.abs(
                poly[z % poly.length][0] - poly[(z - 1) % poly.length][0]
              )
            ))
          )
            dir = 1;
        function yAt(x) {
          for (
            var z = poly.length + minXi;
            z % poly.length != maxXi;
            z += dir
          ) {
            var from = poly[z % poly.length],
              to = poly[(z + dir) % poly.length];
            if (from[0] <= x && x < to[0]) {
              var m = (to[1] - from[1]) / (to[0] - from[0]);
              return m * (x - from[0]) + from[1];
            }
          }
        }

        var curX = poly[minXi][0] * scale,
          curY = poly[minXi][1] * scale;
        var gUps = lgr.grassUp,
          gDowns = lgr.grassDown;
        while (curX < maxX * scale) {
          var bestD = Infinity,
            bestA,
            bestI;
          for (var a = 0; a < gUps.length; a++) {
            if (curX + gUps[a].width >= maxX * scale) continue;
            var dist = Math.abs(
              yAt((curX + gUps[a].width) / scale) * scale -
                (curY - (gUps[a].height - 41))
            );
            if (dist < bestD) {
              bestD = dist;
              bestA = gUps;
              bestI = a;
            }
          }
          for (var a = 0; a < gDowns.length; a++) {
            if (curX + gDowns[a].width >= maxX * scale) continue;
            var dist = Math.abs(
              yAt((curX + gDowns[a].width) / scale) * scale -
                (curY + (gDowns[a].height - 41))
            );
            if (dist < bestD) {
              bestD = dist;
              bestA = gDowns;
              bestI = a;
            }
          }
          if (!bestA) {
            curX++;
            continue;
          }
          var pict = bestA[bestI];
          var fall = (pict.height - 41) * (bestA == gUps ? -1 : 1);
          var fcx = Math.floor(curX);
          var fcyTop = Math.floor(curY) - Math.ceil((pict.height - fall) / 2);

          maxImgW = Math.max(maxImgW, pict.width / scale);
          maxImgH = Math.max(maxImgH, pict.height / scale);

          tree.add(fcx / scale, fcyTop / scale, pict);

          curX += pict.width;
          curY += fall;
        }
      }
    }

    return {
      calc: calc,
      traverse: traverse,
      dbgdraw: function(canv, x, y, w, h) {
        tree.dbgdraw(canv, x, y, w, h);
      }
    };
  })();

  function drawPictures(pics, canv, scale, clipping, x, y, w, h) {
    function draw(pic) {
      // TODO: are masks specifically for textures? dunno
      var img = lgr.picts[pic.picture];
      if (pic.clipping != clipping) return;
      if (img && img.draw) {
        if (!geom.rectsOverlap(pic.x, pic.y, img.width, img.height, x, y, w, h))
          return;
        canv.save();
        canv.translate(pic.x * scale, pic.y * scale);
        canv.scale(scale / 48, scale / 48);
        img.drawAt(canv);
        canv.restore();
        return;
      }
      img = lgr.picts[pic.texture];
      var mask = lgr.picts[pic.mask];
      if (img && img.draw && mask && mask.draw) {
        if (
          !geom.rectsOverlap(pic.x, pic.y, mask.width, mask.height, x, y, w, h)
        )
          return;
        // TODO: scale textures, fix otherwise
        var px = Math.round(pic.x * scale),
          py = Math.round(pic.y * scale);
        var offsX = px >= 0 ? px % img.width : img.width - -px % img.width;
        var offsY = py >= 0 ? py % img.height : img.height - -py % img.height;
        mask.getImage();
        canv.save();
        canv.translate(pic.x * scale, pic.y * scale);
        canv.beginPath();
        canv.moveTo(0, 0);
        canv.lineTo(mask.width * scale / 48, 0);
        canv.lineTo(mask.width * scale / 48, mask.height * scale / 48);
        canv.lineTo(0, mask.height * scale / 48);
        canv.clip();
        canv.translate(-offsX, -offsY);
        img.repeat(
          canv,
          offsX + mask.width * scale / 48,
          offsY + mask.height * scale / 48
        );
        canv.restore();
      }
    }

    pics.forEach(draw);
  }

  var lgrIdent = {};
  var optIdent = {};
  var optGrass = true;
  var optPictures = true;
  var optCustomBackgroundSky = true;

  // (x, y)–(x + w, y + h): viewport in Elma dimensions
  function draw(canv, x, y, w, h, scale) {
    if (lgrIdent != lgr._ident) {
      if (optGrass) grass.calc();
      if (optPictures) pictures.calc();
      lgrIdent = lgr._ident;
    }

    var pics = [];
    pictures.traverse(x, y, w, h, function(x, y, pic) {
      pics.push(pic);
    });
    pics.sort(function(a, b) {
      return (
        (a.dist < b.dist) - (a.dist > b.dist) ||
        (a.num < b.num) - (a.num > b.num)
      );
    });

    if (optPictures) {
      canv.save();
      canv.translate(-x * scale, -y * scale);
      drawPictures(pics, canv, scale, "s", x, y, w, h); // sky
      canv.restore();
    }

    canv.save();
    canv.beginPath();
    canv.moveTo(0, 0);
    canv.lineTo(w * scale, 0);
    canv.lineTo(w * scale, h * scale);
    canv.lineTo(0, h * scale);

    canv.translate(-x * scale, -y * scale);

    traverse(polyTree, false, function(isSolid, verts) {
      canv.moveTo(
        scale * verts[verts.length - 1][0],
        scale * verts[verts.length - 1][1]
      );
      for (var z = verts.length - 2; z >= 0; z--)
        canv.lineTo(scale * verts[z][0], scale * verts[z][1]);
    });

    canv.translate(x * scale, y * scale);
    canv.clip(); // clip isn't antialiased in Chromium—different with destination-out
    void (function() {
      // TODO: check that it's not accessing something it shouldn't
      var img =
        (optCustomBackgroundSky && lgr.picts[reader.ground()]) ||
        lgr.picts.ground;
      var px = Math.floor(x * scale),
        py = Math.floor(y * scale);
      var pw = Math.floor(w * scale),
        ph = Math.floor(h * scale);
      var offsX = x >= 0 ? px % img.width : img.width - -px % img.width;
      var offsY = y >= 0 ? py % img.height : img.height - -py % img.height;
      canv.save();
      canv.translate(-img.width - offsX, -img.height - offsY);
      img.repeat(canv, pw + img.width * 2, ph + img.height * 2);
      canv.restore();
    })();

    if (optPictures) {
      canv.save();
      canv.translate(-x * scale, -y * scale);
      drawPictures(pics, canv, scale, "g", x, y, w, h); // ground
      canv.restore();
    }

    canv.translate(-x * scale, -y * scale);

    if (optGrass) {
      canv.save();
      canv.beginPath();
      grass.traverse(x, y, w, h + 24, function(grassX, grassY, pict) {
        canv.save();
        canv.translate(grassX * scale, grassY * scale);
        var b = pict.borders;
        canv.scale(scale / 48, scale / 48);
        canv.moveTo(0, -24);
        for (var z = 0; z < b.length; z++) {
          canv.lineTo(z, b[z] + 1);
          canv.lineTo(z + 1, b[z] + 1);
        }
        canv.lineTo(pict.width, -24);
        canv.closePath();
        canv.restore();
      });
      canv.clip();

      canv.translate(x * scale, y * scale);

      void (function() {
        var img = lgr.picts.qgrass;
        var px = Math.floor(x * scale),
          py = Math.floor(y * scale);
        var pw = Math.floor(w * scale),
          ph = Math.floor(h * scale);
        var offsX = x >= 0 ? px % img.width : img.width - -px % img.width;
        var offsY = y >= 0 ? py % img.height : img.height - -py % img.height;
        canv.save();
        canv.translate(-img.width - offsX, -img.height - offsY);
        img.repeat(canv, pw + img.width * 2, ph + img.height * 2);
        canv.restore();
      })();
      canv.restore();

      grass.traverse(x, y, w, h, function(grassX, grassY, pict) {
        canv.save();
        canv.translate(grassX * scale, grassY * scale);
        canv.scale(scale / 48, scale / 48);
        pict.drawAt(canv);
        canv.restore();
      });
    }
    canv.restore();

    if (optPictures) {
      canv.save();
      canv.translate(-x * scale, -y * scale);
      drawPictures(pics, canv, scale, "u", x, y, w, h); // unclipped
      canv.restore();
    }

    canv.strokeStyle = "#ff0000";
    if (window.dbg) {
      canv.strokeRect(0, 0, w * scale, h * scale);
      if (window.dbg > 1) {
        canv.save();
        canv.translate(-x * scale, -y * scale);
        canv.scale(scale, scale);
        canv.lineWidth = 1 / 48;
        canv.strokeStyle = "orange";
        if (window.dbg & 2) grass.dbgdraw(canv, x, y, w, h);
        canv.strokeStyle = "purple";
        if (window.dbg & 4) pictures.dbgdraw(canv, x, y, w, h);
        canv.restore();
      }
    }
  }

  function cached(num, mkCanv) {
    var cscale, xp, yp, wp, hp;
    var canvs = [];
    var cacheLgrIdent;
    var cacheOptIdent;

    function update(which, canv) {
      var x = which % num,
        y = Math.floor(which / num);
      x = xp + x * wp;
      y = yp + y * hp;
      var ctx = canv.getContext("2d");
      ctx.clearRect(0, 0, canv.width, canv.height);
      draw(ctx, x / cscale, y / cscale, wp / cscale, hp / cscale, cscale);
    }

    function invalid() {
      return (
        lgr._ident != lgrIdent ||
        cacheLgrIdent != lgrIdent ||
        cacheOptIdent != optIdent
      );
    }

    return function cachedDraw(canv, x, y, w, h, scale) {
      w = Math.ceil(w * scale);
      h = Math.ceil(h * scale);
      x = Math.floor(x * scale);
      y = Math.floor(y * scale);
      if (
        invalid() ||
        scale != cscale ||
        Math.ceil(w / (num - 1)) != wp ||
        Math.ceil(h / (num - 1)) != hp ||
        !geom.rectsOverlap(xp, yp, wp * num, hp * num, x, y, w, h)
      ) {
        cacheLgrIdent = lgrIdent;
        cacheOptIdent = optIdent;
        wp = Math.ceil(w / (num - 1));
        hp = Math.ceil(h / (num - 1));
        xp = x - Math.floor(wp / 2);
        yp = y - Math.floor(hp / 2);
        cscale = scale;
        canvs = [];
        for (var z = 0; z < num * num; z++)
          update(z, (canvs[z] = mkCanv(wp, hp)));
      }
      // TODO: will render things unnecessarily if it jumps a whole column/row
      // doesn't matter when num == 2
      // should try to generalise this—whole thing looks unreadable
      while (yp > y) {
        // stuff missing from top
        yp -= hp;
        canvs.splice.apply(
          canvs,
          [0, 0].concat(canvs.splice(num * (num - 1), num))
        );
        for (var z = 0; z < num; z++) update(z, canvs[z]);
      }
      while (yp + num * hp < y + h) {
        // stuff missing from bottom
        yp += hp;
        canvs.splice.apply(
          canvs,
          [num * (num - 1), 0].concat(canvs.splice(0, num))
        );
        for (var z = 0; z < num; z++)
          update(num * (num - 1) + z, canvs[num * (num - 1) + z]);
      }
      while (xp > x) {
        // stuff missing from left
        xp -= wp;
        for (var z = 0; z < num; z++) {
          canvs.splice(z * num, 0, canvs.splice((z + 1) * num - 1, 1)[0]);
          update(z * num, canvs[z * num]);
        }
      }
      while (xp + num * wp < x + w) {
        // stuff missing from right
        xp += wp;
        for (var z = 0; z < num; z++) {
          canvs.splice((z + 1) * num - 1, 0, canvs.splice(z * num, 1)[0]);
          update((z + 1) * num - 1, canvs[(z + 1) * num - 1]);
        }
      }

      for (var xi = 0; xi < num; xi++)
        for (var yi = 0; yi < num; yi++)
          canv.drawImage(
            canvs[yi * num + xi],
            xp - x + xi * wp,
            yp - y + yi * hp
          );
    };
  }

  return {
    draw: draw,
    cached: cached,
    setGrass: function(v) {
      optGrass = v;
      optIdent = {};
    },
    setPictures: function(v) {
      optPictures = v;
      optIdent = {};
    },
    setCustomBackgroundSky: function(v) {
      optCustomBackgroundSky = v;
      optIdent = {};
    },
    drawSky: function(canv, x, y, w, h, scale) {
      // TODO: check that it's not accessing something it shouldn't
      var img =
        (optCustomBackgroundSky && lgr.picts[reader.sky()]) || lgr.picts.sky;
      x = Math.floor(x * scale / 3);
      w *= scale;
      h *= scale;
      if ((x = x % img.width) < 0) x = img.width + x;
      canv.save();
      canv.translate(-x, 0);
      img.repeat(canv, w + img.width, h);
      canv.restore();
    },
    bounds: function() {
      return { minX, minY, maxX, maxY };
    }
  };
}

function hypot(a, b) {
  return Math.sqrt(a * a + b * b);
}

// (x1, y1)–(x2, y2): line to draw image along
// bx: length of image used before (x1, y1)
// br: length of image used after (x2, y2)
// by: proportional (of ih) y offset within the image the line is conceptually along
// ih: image height
function skewimage(canv, img, bx, by, br, ih, x1, y1, x2, y2, box) {
  var o = x2 - x1,
    a = y2 - y1;
  canv.save();
  canv.translate(x1, y1);
  canv.rotate(Math.atan2(a, o));
  canv.translate(-bx, -by * ih);
  canv.scale(bx + br + hypot(o, a), ih);
  img.draw(canv);
  if (box) {
    canv.strokeStyle = "purple";
    canv.lineWidth = 0.02;
    canv.strokeRect(0, 0, 1, 1);
  }
  canv.restore();
}

function limb(cwInner, fstParams, sndParams) {
  return function(canv, fstImg, x1, y1, sndImg, x2, y2) {
    var dist = hypot(x2 - x1, y2 - y1);
    var fstLen = fstParams.length,
      sndLen = sndParams.length;

    var prod =
      (dist + fstLen + sndLen) *
      (dist - fstLen + sndLen) *
      (dist + fstLen - sndLen) *
      (-dist + fstLen + sndLen);
    var angle = Math.atan2(y2 - y1, x2 - x1);
    var jointangle = 0;
    if (prod >= 0 && dist < fstLen + sndLen) {
      // law of sines
      var circumr = dist * fstLen * sndLen / Math.sqrt(prod);
      jointangle = Math.asin(sndLen / (2 * circumr));
    } else fstLen = fstLen / (fstLen + sndLen) * dist;

    if (cwInner) jointangle *= -1;

    var jointx = x1 + fstLen * Math.cos(angle + jointangle);
    var jointy = y1 + fstLen * Math.sin(angle + jointangle);

    skewimage(
      canv,
      fstImg,
      fstParams.bx,
      fstParams.by,
      fstParams.br,
      fstParams.ih,
      jointx,
      jointy,
      x1,
      y1
    );
    skewimage(
      canv,
      sndImg,
      sndParams.bx,
      sndParams.by,
      sndParams.br,
      sndParams.ih,
      x2,
      y2,
      jointx,
      jointy
    );
  };
}

var legLimb = limb(
  false,
  {
    length: 26.25 / 48,
    bx: 0,
    by: 0.6,
    br: 6 / 48,
    ih: 39.4 / 48 / 3
  },
  {
    length: 1 - 26.25 / 48,
    bx: 5 / 48 / 3,
    by: 0.45,
    br: 4 / 48,
    ih: 60 / 48 / 3
  }
);

var armLimb = limb(
  true,
  {
    length: 0.3234,
    bx: 12.2 / 48 / 3,
    by: 0.5,
    br: 13 / 48 / 3,
    ih: -32 / 48 / 3
  },
  {
    length: 0.3444,
    bx: 3 / 48,
    by: 0.5,
    br: 13.2 / 48 / 3,
    ih: 22.8 / 48 / 3
  }
);

function wheel(canv, lgr, wheelX, wheelY, wheelR) {
  canv.save();
  canv.translate(wheelX, -wheelY);
  canv.rotate(-wheelR);
  canv.scale(38.4 / 48, 38.4 / 48);
  canv.translate(-0.5, -0.5);
  lgr.picts.q1wheel.draw(canv);
  canv.restore();
}

function turnScale(x) {
  return -Math.cos(x * Math.PI);
}

const defaultBikeCoords = {
  bikeR: 10000,
  turn: 0,
  leftX: -849.4,
  leftY: -600.6,
  rightX: 849,
  rightY: -600,
  rightR: 0.42,
  headX: 0,
  headY: 439,
  lastTurnF: -1,
  lv: null,
};

// extracted from recRender so we can draw a bike in start position when there's no replay
function bikeRender(canv, lgr, shirt, frame, x, y, scale, startX, startY, bikeCoords) {
  canv.save();
  canv.translate(
    scale * (-x + startX),
    scale * (-y - startY)
  );
  canv.scale(scale, scale);
  canv.beginPath();

  var coords = bikeCoords ? bikeCoords : defaultBikeCoords;

  var bikeR = coords.bikeR * Math.PI * 2 / 10000;
  var turn = coords.turn;
  var leftX = coords.leftX / 1000;
  var leftY = coords.leftY / 1000;
  var leftR = coords.leftR * Math.PI * 2 / 250;
  var rightX = coords.rightX / 1000;
  var rightY = coords.rightY / 1000;
  var rightR = coords.rightR * Math.PI * 2 / 250;
  var headX = coords.headX / 1000;
  var headY = coords.headY / 1000;
  var lastTurnF = coords.lastTurnF;
  var lv = coords.lv;

  var animlen = 28;
  var animpos =
    lv != null && frame - lv[0] < animlen ? (frame - lv[0]) / animlen : 0;
  var turnpos =
    lastTurnF >= 0 && lastTurnF + 24 > frame ? (frame - lastTurnF) / 24 : 0;

  var backX = !turn ? rightX : leftX;
  var backY = !turn ? rightY : leftY;
  var backR = !turn ? rightR : leftR;
  var frontX = turn ? rightX : leftX;
  var frontY = turn ? rightY : leftY;
  var frontR = turn ? rightR : leftR;

  if (turnpos == 0 || turnpos > 0.5) wheel(canv, lgr, backX, backY, backR);
  if (turnpos <= 0.5) wheel(canv, lgr, frontX, frontY, frontR);

  canv.save();
  canv.rotate(-bikeR);
  if (turn) canv.scale(-1, 1);
  if (turnpos > 0) canv.scale(turnScale(turnpos), 1);

  var wx, wy, a, r;
  var hbarsX = -21.5,
    hbarsY = -17;
  canv.save();
  canv.scale(1 / 48, 1 / 48);

  // front suspension
  wx = turn ? rightX : leftX;
  wy = turn ? -rightY : -leftY;
  a = Math.atan2(wy, (turn ? -1 : 1) * wx) + (turn ? -1 : 1) * bikeR;
  r = hypot(wx, wy);
  skewimage(
    canv,
    lgr.picts.q1susp1,
    2,
    0.5,
    5,
    6,
    48 * r * Math.cos(a),
    48 * r * Math.sin(a),
    hbarsX,
    hbarsY
  );

  // rear suspension
  wx = turn ? leftX : rightX;
  wy = turn ? -leftY : -rightY;
  a = Math.atan2(wy, (turn ? -1 : 1) * wx) + (turn ? -1 : 1) * bikeR;
  r = hypot(wx, wy);
  //skewimage(canv, lgr.picts.q1susp2, 5, 0.5, 5, 6.5, 48*r*Math.cos(a), 48*r*Math.sin(a), 10, 20);
  skewimage(
    canv,
    lgr.picts.q1susp2,
    0,
    0.5,
    5,
    6,
    9,
    20,
    48 * r * Math.cos(a),
    48 * r * Math.sin(a)
  );
  canv.restore();

  canv.save(); // bike
  canv.translate(-43 / 48, -12 / 48);
  canv.rotate(-Math.PI * 0.197);
  canv.scale(0.215815 * 380 / 48, 0.215815 * 301 / 48);
  lgr.picts.q1bike.draw(canv);
  canv.restore();

  canv.save(); // kuski
  r = hypot(headX, headY);
  a = Math.atan2(-headY, turn ? -headX : headX) + (turn ? -bikeR : bikeR);
  wx = r * Math.cos(a);
  wy = r * Math.sin(a);
  canv.translate(wx, wy);

  canv.save(); // head
  canv.translate(-15.5 / 48, -42 / 48);
  canv.scale(23 / 48, 23 / 48);
  lgr.picts.q1head.draw(canv);
  canv.restore();

  var bumx = 19.5 / 48,
    bumy = 0;
  var pedalx = -wx + 10.2 / 48 / 3,
    pedaly = -wy + 65 / 48 / 3;
  legLimb(canv, lgr.picts.q1thigh, bumx, bumy, lgr.picts.q1leg, pedalx, pedaly);

  canv.save(); // torso
  canv.translate(17 / 48, 9.25 / 48);
  canv.rotate(Math.PI + 2 / 3);
  canv.scale(100 / 48 / 3, 58 / 48 / 3);
  if (shirt && shirt.getImage()) {
    // assumes shirts are rotated as on EOL site
    canv.translate(0.5, 0.5);
    canv.rotate(Math.PI / 2);
    canv.translate(-0.5, -0.5);
    shirt.draw(canv);
  } else lgr.picts.q1body.draw(canv);
  canv.restore();

  var shoulderx = 0 / 48,
    shouldery = -17.5 / 48;
  var handlex = -wx - 64.5 / 48 / 3,
    handley = -wy - 59.6 / 48 / 3;
  var handx = handlex,
    handy = handley;

  var animx = shoulderx,
    animy = shouldery;
  if (animpos > 0) {
    var dangle, ascale;
    if (lv[1] == turn) {
      if (animpos >= 0.25) animpos = 0.25 - 0.25 * (animpos - 0.25) / 0.75;
      dangle = 10.8 * animpos;
      ascale = 1 - 1.2 * animpos;
    } else {
      if (animpos >= 0.2) animpos = 0.2 - 0.2 * (animpos - 0.2) / 0.8;
      dangle = -8 * animpos;
      ascale = 1 + 0.75 * animpos;
    }
    var at = Math.atan2(handley - animy, handlex - animx) + dangle;
    var dist = ascale * hypot(handley - animy, handlex - animx);
    handx = animx + dist * Math.cos(at);
    handy = animy + dist * Math.sin(at);
  }

  armLimb(
    canv,
    lgr.picts.q1up_arm,
    shoulderx,
    shouldery,
    lgr.picts.q1forarm,
    handx,
    handy
  );
  canv.restore();
  canv.restore();

  if (turnpos != 0 && turnpos <= 0.5) wheel(canv, lgr, backX, backY, backR);
  if (turnpos > 0.5) wheel(canv, lgr, frontX, frontY, frontR);
  canv.restore();
}

function recRender(reader) {
  var turnFrames = (function() {
    var fc = reader.frameCount();
    var o = [],
      t = 0;
    for (var f = 0; f < fc; f++) {
      var tmp = (reader.turn(f) >> 1) & 1;
      if (tmp != t) o.push(f);
      t = tmp;
    }
    return o;
  })();

  var volts = [];
  void (function() {
    var ec = reader.eventCount();
    var o = [];
    for (var e = 0; e < ec; e++)
      reader.event(e, function(time, info, type, a, b) {
        var frame = Math.ceil(time / 0.01456);
        switch (type) {
          case 5: // turn
            //							turnFrames.push(frame);
            break;
          case 6: // right volt
            volts.push([frame, true]);
            break;
          case 7: // left volt
            volts.push([frame, false]);
            break;
        }
      });
    return o;
  })();

  function lastTurn(frame) {
    for (var x = 0; x < turnFrames.length; x++)
      if (turnFrames[x] > frame) break;
    return x ? turnFrames[x - 1] : -1;
  }

  function lastVolt(frame) {
    for (var x = 0; x < volts.length; x++) if (volts[x][0] > frame) break;
    return x ? volts[x - 1] : null;
  }

  function interpolate(fn) {
    return function(n) {
      var f = Math.floor(n),
        o = n - f,
        r = fn(f);
      if (o == 0) return r;
      return r + (fn(f + 1) - r) * o;
    };
  }

  function interpolateAng(fn, mod) {
    return function(n) {
      var f = Math.floor(n),
        o = n - f,
        r = fn(f);
      if (o == 0) return r;
      var rs = fn(f + 1);
      var diff1 = rs - r,
        diff2 = (rs + mod / 2) % mod - (r + mod / 2) % mod;
      var diff = Math.abs(diff1) < Math.abs(diff2) ? diff1 : diff2;
      return r + diff * o;
    };
  }

  var bikeXi = interpolate(reader.bikeX);
  var bikeYi = interpolate(reader.bikeY);
  var bikeRi = interpolateAng(reader.bikeR, 10000);
  var leftXi = interpolate(reader.leftX);
  var leftYi = interpolate(reader.leftY);
  var leftRi = interpolateAng(reader.leftR, 250);
  var rightXi = interpolate(reader.rightX);
  var rightYi = interpolate(reader.rightY);
  var rightRi = interpolateAng(reader.rightR, 250);
  var headXi = interpolate(reader.headX);
  var headYi = interpolate(reader.headY);

  // (x, y): top left in Elma coordinates
  // arguably a microoptimisation, but it doesn't produce any objects in the JS world
  function draw(canv, lgr, shirt, frame, x, y, scale) {
    var bikeCoords = {};
    bikeCoords.bikeR = bikeRi(frame);
    bikeCoords.turn = (reader.turn(Math.floor(frame)) >> 1) & 1;
    bikeCoords.leftX = leftXi(frame);
    bikeCoords.leftY = leftYi(frame);
    bikeCoords.leftR = leftRi(frame);
    bikeCoords.rightX = rightXi(frame);
    bikeCoords.rightY = rightYi(frame);
    bikeCoords.rightR = rightRi(frame);
    bikeCoords.headX = headXi(frame);
    bikeCoords.headY = headYi(frame);
    bikeCoords.lastTurnF = lastTurn(frame);
    bikeCoords.lv = lastVolt(frame);
    bikeRender(canv, lgr, shirt, frame, x, y, scale, bikeXi(frame), bikeYi(frame), bikeCoords);
  }

  return {
    draw: draw,
    bikeXi: bikeXi,
    bikeYi: bikeYi
  };
}

function objRender(levReader, recReader) {
  var appleCount = 0;

  var objs = (function() {
    var flowers = [],
      apples = [],
      killers = [],
      starts = [];

    function fl(x, y) {
      flowers.push({ type: "fl", pos: [x, y] });
    }

    function ap(x, y, grav, anim) {
      appleCount++;
      apples.push({ type: "ap", pos: [x, y], grav: grav, anim: anim });
    }

    function ki(x, y) {
      killers.push({ type: "ki", pos: [x, y] });
    }

    function st(x, y) {
      starts.push({ type: "st", pos: [x, y] });
    }

    // TODO: handle errors
    var count = levReader.objCount();
    for (var x = 0; x < count; x++) levReader.obj(x, fl, ap, ki, st);

    return [].concat(killers, apples, flowers, starts);
  })();

  var applesTaken = [];
  var gravityChanges = [];
  void (function() {
    for (var rec = 0, recR = recReader; recR; recR = recR.next, rec++) {
      var count = recR.eventCount();
      var gravC = [];
      for (var x = 0; x < count; x++)
        recR.event(x, function(time, info, type) {
          if (type == 0)
            if (
              objs.length > info &&
              objs[info].type == "ap" &&
              !("taken" in objs[info])
            ) {
              // TODO: check it's actually there?
              // TODO: maybe track gravity here?
              var frame = time / 0.01456;
              objs[info].taken = frame;
              applesTaken.push([frame, rec]);
              if (objs[info].grav > 0)
                gravC.push([
                  frame,
                  ["up", "down", "left", "right"][objs[info].grav - 1]
                ]);
            }
        });
      gravityChanges.push(gravC);
    }
    applesTaken.sort(function(a, b) {
      return (a[0] > b[0]) - (a[0] < b[0]);
    });
  })();

  return {
    appleCount: function() {
      return appleCount;
    },

    applesTaken: function(frame, rec) {
      for (var x = 0; x < applesTaken.length; x++)
        if (applesTaken[x][0] >= frame) break;
      return x;
    },

    appleTimes: function () {
      return applesTaken.map((a, i) => ({
        apple: i + 1,
        frame: a[0],
      }));
    },

    gravity: function(frame, rec) {
      var gravC = gravityChanges[rec];
      if (gravC.length == 0)
        // returns empty string if gravity is default for whole rec
        return "";
      for (var x = 0; x < gravC.length; x++) if (gravC[x][0] >= frame) break;
      return x ? gravC[x - 1][1] : "down";
    },

    draw: function (canv, lgr, frame, x, y, w, h, scale, showGravity) {
      canv.save();
      canv.scale(scale, scale);
      canv.translate(-x, -y);

      for (var z = 0; z < objs.length; z++) {
        canv.save();
        canv.translate(objs[z].pos[0], objs[z].pos[1]);
        canv.scale(40 / 48, 40 / 48);
        canv.translate(-0.5, -0.5);
        switch (objs[z].type) {
          case "ap":
            if ("taken" in objs[z] && objs[z].taken <= frame) break;
            lgr.picts[`qfood${objs[z].anim + 1}`].frame(canv, frame, objs[z].grav, showGravity);
            break;
          case "fl":
            lgr.picts.qexit.frame(canv, frame);
            break;
          case "ki":
            lgr.picts.qkiller.frame(canv, frame);
            break;
        }
        canv.restore();
      }
      canv.restore();
    }
  };
}

typeof navigator != "undefined" &&
  navigator.userAgent.indexOf("Firefox") >= 0;

function signum(n) {
  return n < 0 ? -1 : n > 0 ? 1 : 0;
}

function player(levRd, lgr, makeCanvas, autoPlay) {
  var replays, levRn;
  var lastFrame;
  var refFrame, refTime;
  var invalidate;

  var viewports;

  var focus; // whether focus is on replays[0]

  var playing;

  var startX, startY;

  var zoom; // scale = 0.8^zoom, of Elma units, where 1 Elma unit is 48 px
  var speed; // where 1 is normal speed, -1 is reversed

  var defaultObjRn; // for when not spying

  // levRender options; makes sense to persist these
  var optGrass = true;
  var optGravityArrows = true;
  var optPictures = true;
  var optCustomBackgroundSky = true;

  var bounds = null;

  var showStartPos = false;

  reset();

  lgr.playerInvalidate = function() {
    invalidate = true;
  };

  function reset() {
    replays = [];
    levRn = levRender(levRd, lgr);
    updateLevOpts();
    lastFrame = 0;
    refFrame = 0;
    refTime = Date.now();
    invalidate = true;

    viewports = [];

    focus = true;

    playing = autoPlay;

    startX = 0;
    startY = 0;
    void (function() {
      function nvm() {}

      var l = levRd.objCount();
      for (var x = 0; x < l; x++)
        levRd.obj(x, nvm, nvm, nvm, function(x, y) {
          startX = x;
          startY = y;
        });
    })();

    zoom = 0;
    speed = 1;

    bounds = null;

    defaultObjRn = objRender(levRd);
  }

  function updateLevOpts() {
    levRn.setGrass(optGrass);
    levRn.setPictures(optPictures);
    levRn.setCustomBackgroundSky(optCustomBackgroundSky);
  }

  function getViewport(n) {
    if (!viewports[n])
      viewports[n] = {
        offsX: 0,
        offsY: 0,
        // hack! Firefox seems to perform a lot better without the cache
        // suspect it has to do with the offscreen antialiasing it's doing
        // levRn: isMozilla ? levRn.draw : levRn.cached(4, makeCanvas),
        // this "hack" caused major memory leak
        levRn: levRn.cached(4, makeCanvas),
        scaleFac: 1
      };
    return viewports[n];
  }

  function setRef() {
    refFrame = lastFrame;
    refTime = Date.now();
    invalidate = true;
  }

  function calcFrameCount() {
    if (replays.length == 0) return 60 * 30; // animate objects for a minute
    return (
      replays
        .map(function(rp) {
          return rp.frameCount;
        })
        .reduce(function(a, b) {
          return Math.max(a, b);
        }, 0) + 30
    );
  }

  var frameCount = calcFrameCount();

  function setSpeed(n) {
    if (n == 0) return;
    setRef();
    console.log(n);
    return (speed = n);
  }

  function setScale(n) {
    if (n == 0) return;
    setZoom(Math.log(n) / Math.log(0.8));
    return n;
  }

  function setZoom(n) {
    zoom = n;
    setRef();
    return (zoom = n);
  }

  function getScale() {
    return Math.pow(0.8, zoom);
  }

  var dragging = false;

  // (w, h), size of canvas
  function inputClick(x, y, w, h) {
    if (dragging) dragging = false;
    else changeFocus();
  }

  function inputWheel(x, y, w, h, delta) {
    // was planning on making it zoom around the cursor, but
    // .. what if there are multiple viewports?
    setZoom(zoom + signum(delta));
  }

  function inputDrag(x, y, w, h) {
    if (y < 12 && replays.length > 0) return dragSeek(x, y, w);
    return dragPosition(x, y, w, h);
  }

  function dragPosition(x, y, w, h) {
    var vp =
      focus && replays.length > 0
        ? getViewport(Math.floor((y / h) * replays[0].subs.length))
        : getViewport(0);

    var firstOx = vp.offsX,
      firstOy = vp.offsY;

    return {
      update: function(cx, cy) {
        dragging = true;
        invalidate = true;
        vp.offsX = firstOx - (cx - x) / (vp.scaleFac * 48 * getScale());
        vp.offsY = firstOy - (cy - y) / (vp.scaleFac * 48 * getScale());
      },

      end: function() {}
    };
  }

  function dragSeek(x, y, w, h) {
    var firstPlaying = playing;
    playing = false;

    function update(cx, cy) {
      dragging = true;
      if (replays.length == 0) return;
      lastFrame = (replays[0].frameCount * cx) / w;
      if (lastFrame < 0) lastFrame = 0;
      if (lastFrame >= frameCount) lastFrame = frameCount - 1;
      setRef();
    }

    update(x);

    return {
      update: update,

      end: function() {
        playing = firstPlaying;
        setRef();
      }
    };
  }

  function changeFocus() {
    focus = true;
    bounds = null;
    invalidate = true;
    if (replays.length > 0) replays.unshift(replays.pop());
    resetViewports();
    for (var z = 0; z < viewports.length; z++)
      viewports[z].offsX = viewports[z].offsY = 0;
  }

  function unfocus() {
		focus = false;
		invalidate = true;
		resetViewports();
	}

  function fitLev() {
		bounds = levRn.bounds();
		setScale(1);
		invalidate = true;
		resetViewports();
	}
  function appleTimes() {
    if (!replays[0]) {
      return [];
    }
    return replays[0].objRn.appleTimes();
  }

  function startPos() {
    showStartPos = true;
  }

  function resetViewports() {
    for (var z = 0; z < viewports.length; z++) {
      viewports[z].offsX = viewports[z].offsY = 0;
    }
  }

  function playPause() {
    playing = !playing;
    setRef();
  }

  function eround(n) {
    var escale = 48 * getScale();
    return Math.round(n * escale) / escale;
  }

  function drawViewport(vp, canv, x, y, w, h, frame, topRec) {
    canv.save();
    canv.translate(x, y);
    canv.beginPath();
    canv.moveTo(0, 0);
    canv.lineTo(w, 0);
    canv.lineTo(w, h);
    canv.lineTo(0, h);
    canv.clip();

    var centreX = vp.offsX,
      centreY = vp.offsY;
    if (bounds != null) {
      centreX += (bounds.maxX + bounds.minX)/2;
      centreY += (bounds.maxY + bounds.minY)/2;
      var bw = bounds.maxX - bounds.minX;
      var bh = bounds.maxY - bounds.minY;
      vp.scaleFac = Math.min(w/bw, h/bh)/48;
    } else if (topRec) {
      var lf = Math.min(frame, topRec.rd.frameCount() - 1);
      centreX += topRec.rn.bikeXi(lf);
      centreY -= topRec.rn.bikeYi(lf);
      vp.scaleFac = 1;
    } else {
      centreX += startX;
      centreY += startY;
      vp.scaleFac = 1;
    }

    var escale = vp.scaleFac * 48 * getScale();
    var ex = eround(centreX - w / escale / 2),
      ey = eround(centreY - h / escale / 2);
    var ew = eround(w / escale),
      eh = eround(h / escale);

    levRn.drawSky(canv, ex, ey, ew, eh, escale);
    vp.levRn(canv, ex, ey, ew, eh, escale);
    if (replays.length === 0 && showStartPos) {
      bikeRender(canv, lgr, null, 0, ex, ey, escale, startX + 0.84, -startY + 0.6);
    }
    if (focus && replays.length > 0)
      replays[0].objRn.draw(
        canv,
        lgr,
        Math.min(frame, replays[0].frameCount - 1),
        ex,
        ey,
        ew,
        eh,
        escale,
        optGravityArrows // showGravity
      );
    else
      defaultObjRn.draw(
        canv,
        lgr,
        frame,
        ex,
        ey,
        ew,
        eh,
        escale,
        optGravityArrows
      );
    for (var z = replays.length - 1; z >= 0; z--) {
      for (var zx = replays[z].subs.length - 1; zx >= 0; zx--) {
        var rec = replays[z].subs[zx];
        if (rec != topRec)
          // object identity
          rec.rn.draw(
            canv,
            lgr,
            rec.shirt,
            Math.min(frame, rec.rd.frameCount() - 1),
            ex,
            ey,
            escale,
            optGravityArrows // showGravity
          );
      }
    }
    if (topRec)
      topRec.rn.draw(
        canv,
        lgr,
        topRec.shirt,
        Math.min(frame, topRec.rd.frameCount() - 1),
        ex,
        ey,
        escale
      );
    canv.restore();
  }

  function drawFrame(canv, x, y, w, h, frame) {
    x = Math.floor(x);
    y = Math.floor(y);
    w = Math.floor(w);
    h = Math.floor(h);
    canv.save();
    canv.translate(x, y);
    canv.beginPath();
    canv.moveTo(0, 0);
    canv.lineTo(w, 0);
    canv.lineTo(w, h);
    canv.lineTo(0, h);
    canv.clip();

    canv.fillStyle = "yellow";
    canv.fillRect(0, 0, w, h);

    if (focus && replays.length > 0) {
      var vph = Math.floor(h / replays[0].subs.length);
      // the last viewport gets an extra pixel when h%2 == .subs.length%2
      for (var z = 0; z < replays[0].subs.length; z++)
        drawViewport(
          getViewport(z),
          canv,
          0,
          z * vph,
          w,
          vph - (z < replays[0].subs.length - 1),
          frame,
          replays[0].subs[z]
        );
      /*
      var t = Math.floor(
        (Math.min(frame, replays[0].frameCount - 1) * 100) / 30
      );
      canv.font = "14px monospace";
      canv.fillStyle = "yellow";
      var csec = pad(2, t % 100);
      t = Math.floor(t / 100);
      var sec = pad(2, t % 60);
      t = Math.floor(t / 60);
      var timestamp = t + ":" + sec + ":" + csec;

      canv.fillText(timestamp, 10, 12 * 2);
      canv.fillText(
        replays[0].objRn.applesTaken(frame) +
          "/" +
          replays[0].objRn.appleCount(),
        10,
        12 * 3
      );
      canv.fillText(arrow(replays[0].objRn.gravity(frame, 0)), 10, 12*4);
      canv.fillRect((w * frame) / replays[0].frameCount - 2.5, 0, 5, 12);
      */
    } else drawViewport(getViewport(0), canv, x, y, w, h, frame, null);

    canv.restore();

    if ((playing || dragging || invalidate) && replays.length > 0) {
      invalidate = false;
      return {
        currentFrame: frame,
        maxFrames: replays[0].frameCount - 1
      };
    }
  }

  return {
    changeLevel: function(levRd_) {
      levRd = levRd_;
      reset();
    },

    drawFrame: drawFrame,

    draw: function(canv, x, y, w, h, onlyMaybe) {
      var curFrame =
        refFrame + (playing * (Date.now() - refTime) * speed * 30) / 1000;
      if (replays.length > 0) {
        while (frameCount && curFrame >= frameCount) {
          curFrame = refFrame = curFrame - frameCount;
          refTime = Date.now();
        }
        while (frameCount && curFrame < 0) {
          curFrame = refFrame = frameCount + curFrame;
          refTime = Date.now();
        }
      }

      if (onlyMaybe && lastFrame == curFrame && !invalidate) return;
      lastFrame = curFrame;
      return drawFrame(canv, x, y, w, h, lastFrame);
    },

    addReplay: function(recRd, recName, shirts) {
      var replay = { recName: recName, objRn: objRender(levRd, recRd), subs: [] };
      while (recRd) {
        replay.subs.push({
          rd: recRd,
          rn: recRender(recRd),
          objRn: objRender(levRd, recRd),
          shirt: shirts[0] || null
        });
        recRd = recRd.next;
        shirts = shirts.slice(1);
      }
      replay.frameCount = replay.subs.reduce(function(a, b) {
        return Math.max(a, b.rd.frameCount());
      }, 0);
      replays.push(replay);
      frameCount = calcFrameCount();
    },

    removeReplay: function(recName) {
      replays = replays.filter(function(r) {
        return r.recName !== recName;
      });
    },

    loadedRecs: function() {
      return replays.map(function(r) {
        return r.recName
      });
    },

    changeFocus: changeFocus,
    unfocus: unfocus,
    fitLev: fitLev,
    appleTimes: appleTimes,
    startPos: startPos,

    setSpeed: setSpeed,
    setScale: setScale,
    setZoom: setZoom,
    speed: function() {
      return speed;
    },
    // scale is deprecated, should prefer to use zoom instead
    scale: function() {
      return getScale();
    },
    zoom: function() {
      return zoom;
    },

    setLevOpts: function(o) {
      if ("grass" in o) optGrass = o.grass;
      if ("arrows" in o) optGravityArrows = o.arrows;
      if ("pictures" in o) optPictures = o.pictures;
      if ("customBackgroundSky" in o)
        optCustomBackgroundSky = o.customBackgroundSky;
      updateLevOpts();
    },

    setFrame: function(s) {
      lastFrame = s;
      setRef();
    },
    frame: function() {
      return lastFrame; // TODO: this is a hack
    },

    playPause: playPause,
    playing: function() {
      return playing;
    },

    inputKey: function(key) {
      switch (key) {
        case " ":
          playPause();
          break;
        case "-":
          setSpeed(speed * 0.8); // 0.8^n is actually representable
          break;
        case "+":
          setSpeed(speed / 0.8);
          break;
        case "Backspace":
          setSpeed(signum(speed));
          break;
        case "f":
          fitLev();
          break;
        case "w":
          setZoom(zoom + 1);
          break;
        case "e":
          setZoom(zoom - 1);
          break;
        case "r":
          setSpeed(-speed);
          break;
        case "p":
          var val = !optCustomBackgroundSky;
          optPictures = optCustomBackgroundSky = val;
          updateLevOpts();
          break;
        case "g":
          optGrass = !optGrass;
          updateLevOpts();
          break;
        case "a":
          optGravityArrows = !optGravityArrows;
          break;
        case "G":
          optGrass = optPictures = optCustomBackgroundSky = true;
          updateLevOpts();
          break;
        case "ArrowRight":
          lastFrame += 30 * 2.5 * speed;
          setRef();
          break;
        case "ArrowLeft":
          lastFrame -= 30 * 2.5 * speed;
          setRef();
          break;
        default:
          return false;
      }
      return true;
    },

    inputClick: inputClick,
    inputDrag: inputDrag,
    inputWheel: inputWheel,

    invalidate: function() {
      invalidate = true;
    }
  };
}

/**
 * @param {Object} arguments
 * @param {string} arguments.levelUrl - Url path to the level file
 * @param {HTMLElement} arguments.elem - <div> element which to attach the recplayer
 * @param {Document} arguments.document - document node of the webpage
 * @param {Function} arguments.onFrameUpdate - function to call when a new frame is drawn
 * @param {boolean} arguments.autoPlay - whether to automatically start the replay
 * @param {string} arguments.lgrFrom - 'file', 'level', 'legacy'
 * 'file': use a direct lgr filepath e.g. lgrUrl = 'http://api.elma.online/api/lgr/get/default'
 * 'level': determine the lgr from the level file e.g. lgrUrl = 'http://api.elma.online/api/lgr/get/'
 * 'legacy': use legacy .png images e.g. legacy_url = 'https://api.elma.online/recplayer'
 * @param {string} arguments.lgrUrl - Contains a path to lgr resources based on the parameter lgrFrom
 * @param {string} arguments.defaultLgrUrl - Backup lgr if unable to load main lgr e.g. 'http://api.elma.online/api/lgr/get/default'
 * @param {string} arguments.legacy_url - Contains a path to png lgr resources if the parameter lgrFrom is 'legacy'
 */
function controller(_args) {
  let args = _args;
  // Handle legacy arguments for backwards-compatibility:
  // controller(levelName, imagesPath, elem, document, onFrameUpdate, autoPlay)
  if(arguments.length > 1) {
    args = {
      levelUrl: arguments[0],
      legacy_url: arguments[1],
      elem: arguments[2],
      document: arguments[3],
      onFrameUpdate: arguments[4],
      autoPlay: arguments[5],
      lgrFrom: 'legacy'
    };
  }
  const {levelUrl, elem, document, onFrameUpdate, autoPlay, lgrFrom, lgrUrl, defaultLgrUrl, legacy_url} = args;

  var createElement =
    "createElementNS" in document
      ? function(tag) {
          return document.createElementNS("http://www.w3.org/1999/xhtml", tag);
        }
      : function(tag) {
          return document.createElement(tag);
        };

  function mkCanv(w, h) {
    var o = createElement("canvas");
    o.width = w;
    o.height = h;
    return o;
  }

  return function(cont) {
    var canvase = mkCanv(600, 480);
    var canvas = canvase.getContext("2d");
    elem.appendChild(canvase);

    // Try to download the level and lgr at the same time (unless we need to get the lgr name from the level file)
    var pllgr = null;
    var levRd = null;
    const assetLoaded = () => {
      if (pllgr && levRd) {
        setup();
      }
      if (levRd && !pllgr && lgrFrom === 'level') {
        var lgrUrlComplete = `${lgrUrl}${levRd.lgr()}`;
        getLgrFile(lgrUrlComplete);
      }
    };

    getString(levelUrl, function(lev) {
      levRd = levReader(lev);
      assetLoaded();
    });

    const getBackupLgr = (originalUrl) => () => {
      // If we are unsuccessful at downloading the main lgr, try to download default.lgr, or else use legacy png lgr
      console.log(`Recplayer - Unable to load ${originalUrl}, trying to load ${defaultLgrUrl} instead`);
      getArray(defaultLgrUrl, lgrFile => {
        pllgr = new LGRWrapper(lgrFile, undefined);
        assetLoaded();
      }, () => {
        console.log(`Recplayer - Unable to load ${defaultLgrUrl}, using legacy .png files`);
        legacy_getLgr();
      });
    };
    const legacy_getLgr = () => {
      pllgr = new LGRWrapper(null, legacy_url);
      assetLoaded();
    };
    const getLgrFile = (url) => {
      getArray(url, lgrFile => {
        pllgr = new LGRWrapper(lgrFile, undefined);
        assetLoaded();
      }, getBackupLgr(url));
    };
    if (lgrFrom === 'legacy') {
      legacy_getLgr();
    }
    if (lgrFrom === 'file') {
      getLgrFile(lgrUrl);
    }

    const setup = function() {
      var pl = player(levRd, pllgr, mkCanv, autoPlay);

      function listener(e) {
        if (pl.inputKey(e.key)) e.preventDefault();
      }

      canvase.setAttribute("tabindex", "0");
      canvase.addEventListener("keydown", listener, true);
      var play = true;
      var animationLoop;
      var loop =
        typeof requestAnimationFrame != "undefined"
          ? function(fn) {
              void (function go() {
                fn();
                play && requestAnimationFrame(go);
              })();
            }
          : function(fn) {
              var fps = 30;
              animationLoop = setInterval(fn, 1000 / fps);
            };

      function draw() {
        var status = pl.draw(canvas, 0, 0, canvase.width, canvase.height, true);
        status && onFrameUpdate(status.currentFrame, status.maxFrames);
      }
      loop(draw);

      function rect() {
        return canvase.getBoundingClientRect();
      }

      canvase.addEventListener("click", function(e) {
        var r = rect();
        pl.inputClick(
          e.clientX - r.left,
          e.clientY - r.top,
          canvase.width,
          canvase.height
        );
        e.preventDefault();
      });

      canvase.addEventListener("mousedown", function(e) {
        var r = rect();
        var cont = pl.inputDrag(
          e.clientX - r.left,
          e.clientY - r.top,
          canvase.width,
          canvase.height
        );

        function onmousemove(e) {
          cont.update(e.clientX - r.left, e.clientY - r.top);
          e.preventDefault();
        }

        function onmouseup() {
          cont.end();
          // /me dislikes function identity
          document.removeEventListener("mousemove", onmousemove);
          document.removeEventListener("mouseup", onmouseup);
          e.preventDefault();
        }

        document.addEventListener("mousemove", onmousemove);
        document.addEventListener("mouseup", onmouseup);
      });

      canvase.addEventListener("touchstart", function ontouchstart(e) {
        var ts = e.changedTouches;
        var r = rect();

        if (ts.length < 1) return;
        e.preventDefault();

        var cont = pl.inputDrag(
          ts[0].clientX - r.left,
          ts[0].clientY - r.top,
          canvase.width,
          canvase.height
        );

        var isClick = true;

        function ontouchmove(e) {
          var ts = e.changedTouches;
          if (ts.length < 1) return;
          isClick = false;
          cont.update(ts[0].clientX - r.left, ts[0].clientY - r.top);
          e.preventDefault();
        }

        function ontouchend() {
          cont.end();
          if (isClick)
            pl.inputClick(
              ts[0].clientX - r.left,
              ts[0].clientY - r.top,
              canvase.width,
              canvase.height
            );
          // ..
          document.removeEventListener("touchmove", ontouchmove);
          document.removeEventListener("touchend", ontouchend);
          document.removeEventListener("touchcancel", ontouchend);

          canvase.addEventListener("touchstart", ontouchstart);
        }

        document.addEventListener("touchmove", ontouchmove);
        document.addEventListener("touchend", ontouchend);
        document.addEventListener("touchcancel", ontouchend);

        canvase.removeEventListener("touchstart", ontouchstart);
      });

      canvase.addEventListener("wheel", function(e) {
        var r = rect();
        var delta =
          e.deltaMode == WheelEvent.DOM_DELTA_LINE
            ? (53 / 3) * e.deltaY
            : e.deltaY;
        pl.inputWheel(
          e.clientX - r.left,
          e.clientY - r.top,
          canvase.width,
          canvase.height,
          delta
        );
        e.preventDefault();
      });

      cont({
        loadReplay: function(recName, shirts) {
          getString(recName, function(rec) {
            if (rec) {
              pl.addReplay(
                recReader(rec),
                !shirts
                  ? []
                  : shirts.map(function(s) {
                      return s == null ? null : new UrlImage(pllgr, '', s);
                    })
              );
            }
          });
        },

        loadReplays: function(recNames, shirts) {
          let loadedShirt = !shirts
            ? []
            : shirts.map(function(s) {
                return s == null ? null : new UrlImage(pllgr, '', s);
              });

          recNames.map(function(r) {
            return getString(r, function(rec) {
              pl.addReplay(recReader(rec), r, [loadedShirt[0]]);
              loadedShirt = loadedShirt.slice(1);
            });
          });
        },

        changeReplays: function(recNames, shirts) {
          const loadedRecs = pl.loadedRecs();

          loadedRecs.forEach(function(r) {
            if (!recNames.includes(r)) {
              pl.removeReplay(r);
            }
          });

          const newRecs = [];
          const newShirts = [];

          recNames.forEach(function(r, i) {
            if (loadedRecs.includes(r)) {
              return;
            }

            newRecs.push(r);
            newShirts.push(shirts[i]);
          });

          let loadedShirt = newShirts.map(function(s) {
            return s == null ? null : new UrlImage(pllgr, '', s);
          });

          newRecs.map(function(r) {
            return getString(r, function(rec) {
              pl.addReplay(recReader(rec), r, [loadedShirt[0]]);
              loadedShirt = loadedShirt.slice(1);
            });
          });
        },

        removeAnimationLoop: function() {
          play = false;
          animationLoop && window.clearInterval(animationLoop);
        },

        loadLevel: function(levelUrl, cont) {
          getString(levelUrl, function(lev) {
            pl.changeLevel(levReader(lev));
            if (cont) cont();
          });
        },

        resize: function(wd, ht) {
          canvase.width = wd;
          canvase.height = ht;
          pl.invalidate();
        },

        setFrame: function(frame) {
          pl.setFrame(frame);
        },

        player: function() {
          return pl;
        },
      });
    };
  };
}

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".RecPlayer {\r\n  position: relative;\r\n  overflow: hidden;\r\n}\r\n\r\n.RecPlayer-player-container {\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\n.RecPlayer-fullscreen .RecPlayer-player-container {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  z-index: 100;\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\n.RecPlayer-controls-button img {\r\n  width: 15px;\r\n  height: 15px;\r\n  display: block;\r\n}\r\n\r\n.RecPlayer:hover .RecPlayer-controls {\r\n  transition-delay: 0s;\r\n}\r\n\r\n.RecPlayer-controls {\r\n  position: absolute;\r\n  bottom: 0;\r\n  color: #fff;\r\n  width: 100%;\r\n  opacity: 0;\r\n  transition-delay: 1s;\r\n}\r\n\r\n.RecPlayer-player-container:hover .RecPlayer-controls,\r\n.RecPlayer-player-container:focus .RecPlayer-controls,\r\n.RecPlayer-progressBar-drag .RecPlayer-controls {\r\n  opacity: 1;\r\n}\r\n\r\n.RecPlayer-controls-button {\r\n  padding: 12px;\r\n  float: left;\r\n  cursor: pointer;\r\n}\r\n\r\n.RecPlayer-controls-progress-bar {\r\n  height: 10px;\r\n  margin-bottom: -6px;\r\n  position: relative;\r\n  user-select: none;\r\n  padding-top: 6px;\r\n}\r\n\r\n.RecPlayer-controls-progress-bar:hover {\r\n  cursor: pointer;\r\n}\r\n\r\n.RecPlayer-controls-progress-bar-background {\r\n  height: 4px;\r\n  background: #3a3a3a;\r\n  overflow: hidden;\r\n}\r\n\r\n.RecPlayer-controls-progress-bar-progress {\r\n  background: #fff;\r\n  height: 100%;\r\n  width: 0;\r\n}\r\n\r\n.RecPlayer-controls-button-fullscreen {\r\n  float: right;\r\n}\r\n\r\n.RecPlayer-controls-button-zoom {\r\n  float: right;\r\n  padding: 10px;\r\n}\r\n\r\n.RecPlayer-controls-button-zoom img {\r\n  width: 18px;\r\n  height: 18px;\r\n}\r\n\r\n.Recplayer-controls-text {\r\n  line-height: 2.4rem;\r\n  font-family: monospace;\r\n  font-size: 0.8rem;\r\n  font-weight: 500;\r\n  font-family: \"Roboto Mono\", monospace;\r\n}\r\n\r\n.RecPlayer-controls-latest-apple {\r\n  padding: 0 12px 0 0;\r\n  float: right;  \r\n}\r\n\r\n.RecPlayer-controls-speed-text {\r\n  float: right;\r\n}\r\n\r\n.RecPlayer canvas {\r\n  display: block;\r\n}\r\n@import url(\"https://fonts.googleapis.com/css?family=Roboto+Mono:400,700\");\r\n.RecPlayer-controls-timestamp {\r\n  padding: 0;\r\n  float: left;\r\n}\r\n\r\n.RecPlayer-controls-bottom-row {\r\n  background: #212121;\r\n  overflow: hidden;\r\n  z-index: 9;\r\n}\r\n";
styleInject(css_248z);

var img$7 = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8' standalone='no'%3f%3e%3csvg xmlns:dc='http://purl.org/dc/elements/1.1/' xmlns:cc='http://creativecommons.org/ns%23' xmlns:rdf='http://www.w3.org/1999/02/22-rdf-syntax-ns%23' xmlns:svg='http://www.w3.org/2000/svg' xmlns='http://www.w3.org/2000/svg' version='1.1' id='svg4241' viewBox='0 0 15.000003 20' height='5.6444445mm' width='4.2333341mm'%3e %3cdefs id='defs4243' /%3e %3cmetadata id='metadata4246'%3e %3crdf:RDF%3e %3ccc:Work rdf:about=''%3e %3cdc:format%3eimage/svg%2bxml%3c/dc:format%3e %3cdc:type rdf:resource='http://purl.org/dc/dcmitype/StillImage' /%3e %3cdc:title%3e%3c/dc:title%3e %3c/cc:Work%3e %3c/rdf:RDF%3e %3c/metadata%3e %3cg transform='translate(-89.642857%2c-270.93363)' id='layer1'%3e %3cpath id='path4157' d='m 89.642857%2c270.93363 0%2c20 15.000003%2c-10 z' style='display:inline%3bfill:white%3bfill-rule:evenodd%3bstroke:none%3bstroke-width:1px%3bstroke-linecap:butt%3bstroke-linejoin:miter%3bstroke-opacity:1' /%3e %3c/g%3e%3c/svg%3e";

var img$6 = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8' standalone='no'%3f%3e%3csvg xmlns:dc='http://purl.org/dc/elements/1.1/' xmlns:cc='http://creativecommons.org/ns%23' xmlns:rdf='http://www.w3.org/1999/02/22-rdf-syntax-ns%23' xmlns:svg='http://www.w3.org/2000/svg' xmlns='http://www.w3.org/2000/svg' version='1.1' id='svg4241' viewBox='0 0 15 20' height='5.6444445mm' width='4.2333331mm'%3e %3cdefs id='defs4243' /%3e %3cmetadata id='metadata4246'%3e %3crdf:RDF%3e %3ccc:Work rdf:about=''%3e %3cdc:format%3eimage/svg%2bxml%3c/dc:format%3e %3cdc:type rdf:resource='http://purl.org/dc/dcmitype/StillImage' /%3e %3cdc:title%3e%3c/dc:title%3e %3c/cc:Work%3e %3c/rdf:RDF%3e %3c/metadata%3e %3cg transform='translate(-116.60714%2c-283.16577)' id='layer1'%3e %3cpath id='path4177' d='m 116.60714%2c283.16577 0%2c20 5%2c0 0%2c-20 z' style='fill:white%3bfill-opacity:1%3bfill-rule:evenodd%3bstroke:none%3bstroke-width:1px%3bstroke-linecap:butt%3bstroke-linejoin:miter%3bstroke-opacity:1' /%3e %3cpath id='path4181' d='m 126.60714%2c283.16577 0%2c20 5%2c0 0%2c-20 z' style='fill:white%3bfill-opacity:1%3bfill-rule:evenodd%3bstroke:none%3bstroke-width:1px%3bstroke-linecap:butt%3bstroke-linejoin:miter%3bstroke-opacity:1' /%3e %3c/g%3e%3c/svg%3e";

var img$5 = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8' standalone='no'%3f%3e%3csvg xmlns:dc='http://purl.org/dc/elements/1.1/' xmlns:cc='http://creativecommons.org/ns%23' xmlns:rdf='http://www.w3.org/1999/02/22-rdf-syntax-ns%23' xmlns:svg='http://www.w3.org/2000/svg' xmlns='http://www.w3.org/2000/svg' version='1.1' id='svg4241' viewBox='0 0 20.000005 19.999998' height='5.644444mm' width='5.6444454mm'%3e %3cdefs id='defs4243' /%3e %3cmetadata id='metadata4246'%3e %3crdf:RDF%3e %3ccc:Work rdf:about=''%3e %3cdc:format%3eimage/svg%2bxml%3c/dc:format%3e %3cdc:type rdf:resource='http://purl.org/dc/dcmitype/StillImage' /%3e %3cdc:title%3e%3c/dc:title%3e %3c/cc:Work%3e %3c/rdf:RDF%3e %3c/metadata%3e %3cg transform='translate(-94.374996%2c-271.29077)' id='layer1'%3e %3cpath id='path4185' d='m 94.374996%2c271.29077 0%2c8 4%2c0 0%2c-4 4.000004%2c0 0%2c-4 z' style='fill:white%3bfill-opacity:1%3bfill-rule:evenodd%3bstroke:none%3bstroke-width:1px%3bstroke-linecap:butt%3bstroke-linejoin:miter%3bstroke-opacity:1' /%3e %3cpath id='path4185-3' d='m 114.375%2c271.29077 -8%2c0 0%2c4 4%2c0 0%2c4 4%2c0 z' style='fill:white%3bfill-opacity:1%3bfill-rule:evenodd%3bstroke:none%3bstroke-width:1px%3bstroke-linecap:butt%3bstroke-linejoin:miter%3bstroke-opacity:1' /%3e %3cpath id='path4185-3-5' d='m 114.375%2c291.29077 0%2c-8 -4%2c0 0%2c4 -4%2c0 0%2c4 z' style='fill:white%3bfill-opacity:1%3bfill-rule:evenodd%3bstroke:none%3bstroke-width:1px%3bstroke-linecap:butt%3bstroke-linejoin:miter%3bstroke-opacity:1' /%3e %3cpath id='path4185-3-5-8' d='m 94.374996%2c291.29077 0%2c-8 4%2c0 0%2c4 4.000004%2c0 0%2c4 z' style='fill:white%3bfill-opacity:1%3bfill-rule:evenodd%3bstroke:none%3bstroke-width:1px%3bstroke-linecap:butt%3bstroke-linejoin:miter%3bstroke-opacity:1' /%3e %3c/g%3e%3c/svg%3e";

var img$4 = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3e%3cpath fill='white' d='M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM136 184c-13.3 0-24 10.7-24 24s10.7 24 24 24H280c13.3 0 24-10.7 24-24s-10.7-24-24-24H136z'/%3e%3c/svg%3e";

var img$3 = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3e%3cpath fill='white' d='M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM184 296c0 13.3 10.7 24 24 24s24-10.7 24-24V232h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H232V120c0-13.3-10.7-24-24-24s-24 10.7-24 24v64H120c-13.3 0-24 10.7-24 24s10.7 24 24 24h64v64z'/%3e%3c/svg%3e";

var img$2 = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3e%3cpath fill='white' d='M142.9 142.9c62.2-62.2 162.7-62.5 225.3-1L327 183c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8H463.5c0 0 0 0 0 0H472c13.3 0 24-10.7 24-24V72c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2L413.4 96.6c-87.6-86.5-228.7-86.2-315.8 1C73.2 122 55.6 150.7 44.8 181.4c-5.9 16.7 2.9 34.9 19.5 40.8s34.9-2.9 40.8-19.5c7.7-21.8 20.2-42.3 37.8-59.8zM16 312v7.6 .7V440c0 9.7 5.8 18.5 14.8 22.2s19.3 1.7 26.2-5.2l41.6-41.6c87.6 86.5 228.7 86.2 315.8-1c24.4-24.4 42.1-53.1 52.9-83.7c5.9-16.7-2.9-34.9-19.5-40.8s-34.9 2.9-40.8 19.5c-7.7 21.8-20.2 42.3-37.8 59.8c-62.2 62.2-162.7 62.5-225.3 1L185 329c6.9-6.9 8.9-17.2 5.2-26.2s-12.5-14.8-22.2-14.8H48.4h-.7H40c-13.3 0-24 10.7-24 24z'/%3e%3c/svg%3e";

var img$1 = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3e%3cpath fill='white' d='M52.5 440.6c-9.5 7.9-22.8 9.7-34.1 4.4S0 428.4 0 416V96C0 83.6 7.2 72.3 18.4 67s24.5-3.6 34.1 4.4L224 214.3V256v41.7L52.5 440.6zM256 352V256 128 96c0-12.4 7.2-23.7 18.4-29s24.5-3.6 34.1 4.4l192 160c7.3 6.1 11.5 15.1 11.5 24.6s-4.2 18.5-11.5 24.6l-192 160c-9.5 7.9-22.8 9.7-34.1 4.4s-18.4-16.6-18.4-29V352z'/%3e%3c/svg%3e";

var img = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3e%3cpath fill='white' d='M459.5 440.6c9.5 7.9 22.8 9.7 34.1 4.4s18.4-16.6 18.4-29V96c0-12.4-7.2-23.7-18.4-29s-24.5-3.6-34.1 4.4L288 214.3V256v41.7L459.5 440.6zM256 352V256 128 96c0-12.4-7.2-23.7-18.4-29s-24.5-3.6-34.1 4.4l-192 160C4.2 237.5 0 246.5 0 256s4.2 18.5 11.5 24.6l192 160c9.5 7.9 22.8 9.7 34.1 4.4s18.4-16.6 18.4-29V352z'/%3e%3c/svg%3e";

var RecPlayer = /*#__PURE__*/function (_Component) {
  _inherits(RecPlayer, _Component);
  var _super = _createSuper(RecPlayer);
  function RecPlayer(props) {
    var _this;
    _classCallCheck(this, RecPlayer);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "changeReplays", function (recUrl, shirtUrl) {
      var recs = recUrl.split(";");
      _this.cnt.changeReplays(recs, shirtUrl);
    });
    _defineProperty(_assertThisInitialized(_this), "recreateController", function (recUrl, levUrl, shirtUrl) {
      _this.removeAnimationLoop();

      // Ensure canvas is removed only if it exists
      var canvas = _this.playerContainerRef.current.querySelector("canvas");
      if (canvas) {
        canvas.remove();
      }
      _this.initPlayer({
        levUrl: levUrl,
        recUrl: recUrl,
        shirtUrl: shirtUrl
      });
    });
    _defineProperty(_assertThisInitialized(_this), "removeAnimationLoop", function () {
      if (_this.cnt) {
        _this.cnt.removeAnimationLoop();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "frameCallback", function (currentFrame, maxFrames) {
      if (_this._isMounted) {
        _this.setState({
          maxFrames: maxFrames,
          currentFrame: currentFrame > maxFrames ? maxFrames : currentFrame,
          progress: currentFrame / maxFrames * 100
        });
        if (currentFrame >= maxFrames && _this.state.currentFrame < maxFrames && _this.props.onEnd) {
          _this.props.onEnd();
        }
      }
    });
    _defineProperty(_assertThisInitialized(_this), "initPlayer", function (urls) {
      // Check if canvas already exists before creating a new one
      if (_this.playerContainerRef.current.querySelector("canvas")) {
        return;
      }
      controller(
      /*//Legacy way of passing parameters:
      urls.levUrl,
      'https://api.elma.online/recplayer',
      this.playerContainerRef.current,
      document,
      this.frameCallback,
      this.props.autoPlay || false,*/
      {
        levelUrl: urls.levUrl,
        elem: _this.playerContainerRef.current,
        document: document,
        onFrameUpdate: _this.frameCallback,
        autoPlay: _this.props.autoPlay || false,
        lgrFrom: _this.props.lgrFrom || 'legacy',
        lgrUrl: _this.props.lgrUrl || 'https://api.elma.online/lgr/get/',
        defaultLgrUrl: _this.props.defaultLgrUrl || 'https://api.elma.online/lgr/get/default',
        legacy_url: _this.props.legacyLgrUrl || 'https://api.elma.online/recplayer'
      })(function (cnt) {
        _this.cnt = cnt;
        _this.autoResize();
        if (urls.recUrl) {
          var recs = urls.recUrl.split(";");
          cnt.loadReplays(recs, urls.shirtUrl);
        }
        cnt.player().setScale(_this.props.zoom || 0.8);
        if (_this.props.levelOptions) {
          var _this$props$levelOpti = _this.props.levelOptions,
            grass = _this$props$levelOpti.grass,
            pictures = _this$props$levelOpti.pictures,
            customBackgroundSky = _this$props$levelOpti.customBackgroundSky,
            arrows = _this$props$levelOpti.arrows;
          cnt.player().setLevOpts({
            grass: typeof grass === "boolean" ? grass : true,
            pictures: typeof pictures === "boolean" ? pictures : true,
            customBackgroundSky: typeof customBackgroundSky === "boolean" ? customBackgroundSky : true,
            arrows: typeof arrows === "boolean" ? arrows : true
          });
        }
        if (_this.props.onInitialize) {
          _this.props.onInitialize(cnt);
        }
        _this.enableWakeLock();
        if (_this.props.fitLev) {
          cnt.player().fitLev();
        }
        if (!urls.recUrl) {
          if (_this.props.showStartPos) {
            cnt.player().startPos();
          }
        }
      });
    });
    _defineProperty(_assertThisInitialized(_this), "autoResize", function () {
      if (_this.cnt && _this.playerContainerRef.current) {
        var w = (_this.props.width == "auto" || _this.state.fullscreen) && _this.playerContainerRef.current.offsetWidth || _this.props.width;
        var h = (_this.props.height == "auto" || _this.state.fullscreen) && _this.playerContainerRef.current.offsetHeight || _this.props.height;
        _this.cnt.resize(w, h);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "playPause", function () {
      if (_this.cnt) {
        _this.cnt.player().playPause();
        var isPlaying = _this.cnt.player().playing();
        if (isPlaying) {
          _this.enableWakeLock();
        } else {
          _this.disableWakeLock();
        }
        _this.setState({
          playing: isPlaying
        });
        _this.props.onPlayPause && _this.props.onPlayPause(isPlaying);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "fullscreen", function () {
      _this.setState(function (prevState, props) {
        return {
          fullscreen: !prevState.fullscreen
        };
      }, _this.autoResize);
    });
    _defineProperty(_assertThisInitialized(_this), "goToFrame", function (frame) {
      if (_this.cnt) {
        _this.cnt.setFrame(frame);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "progressBarOnMouseDown", function (e) {
      if (_this.cnt) {
        _this.setState({
          progressBarDrag: true
        });
        _this._wasPlaying = _this.cnt.player().playing();
        if (_this._wasPlaying) {
          _this.playPause();
        }
        _this.goToFrame(_this.state.maxFrames * (e.nativeEvent.offsetX / e.currentTarget.offsetWidth));
      }
    });
    _defineProperty(_assertThisInitialized(_this), "progressBarOnTouchStart", function () {
      _this._wasPlaying = _this.cnt.player().playing();
      if (_this._wasPlaying) {
        _this.playPause();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "progressBarOnTouchMove", function (e) {
      if (_this._progressBar) {
        var pos = (e.touches[0].clientX - _this._progressBar.getBoundingClientRect().left) / _this._progressBar.offsetWidth;
        if (pos < 0) pos = 0;else if (pos > 1) pos = 1;
        _this.goToFrame(_this.state.maxFrames * pos);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onMouseUp", function () {
      setTimeout(function () {
        _this._mouseDrag = false;
        _this._mouseDown = false;
      }, 100);
      if (_this.state.progressBarDrag && _this._wasPlaying) {
        _this.playPause();
      }
      _this.setState({
        progressBarDrag: false
      });
    });
    _defineProperty(_assertThisInitialized(_this), "progressBarOnTouchEnd", function () {
      if (_this._wasPlaying) {
        _this.playPause();
      }
      _this.setState({
        progressBarDrag: false
      });
    });
    _defineProperty(_assertThisInitialized(_this), "onMouseMove", function (e) {
      if (_this._mouseDown) _this._mouseDrag = true;
      if (_this.state.progressBarDrag && _this._progressBar) {
        var pos = (e.pageX - _this._progressBar.getBoundingClientRect().left) / _this._progressBar.offsetWidth;
        if (pos < 0) pos = 0;else if (pos > 1) pos = 1;
        _this.goToFrame(_this.state.maxFrames * pos);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "frameToTimestamp", function (frame) {
      var time = Math.floor(frame * 100 / 30);
      var csec = (time % 100).toString().padStart(2, 0);
      time = Math.floor(time / 100);
      var sec = (time % 60).toString().padStart(2, 0);
      time = Math.floor(time / 60);
      return time > 0 ? time + ":" + sec + ":" + csec : sec + ":" + csec;
    });
    _defineProperty(_assertThisInitialized(_this), "playerContainerOnTouchStart", function (e) {
      _this.playerContainerRef.current.focus();
      if (e.touches.length === 2) {
        _this._pinch = true;
      }
    });
    _defineProperty(_assertThisInitialized(_this), "playerContainerOnTouchEnd", function (e) {
      _this._pinch = false;
      _this._preDist = null;
    });
    _defineProperty(_assertThisInitialized(_this), "playerContainerOnTouchMove", function (e) {
      if (_this._pinch) {
        var dist = Math.hypot(e.touches[0].pageX - e.touches[1].pageX, e.touches[0].pageY - e.touches[1].pageY);
        if (_this._preDist) {
          var pl = _this.cnt.player();
          var scale = pl.scale();
          if (_this._preDist < dist) {
            pl.setScale(scale * 1.2);
          } else {
            pl.setScale(scale / 1.2);
          }
        }
        _this._preDist = dist;
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onClick", function (e) {
      if (e.target.localName === "canvas" && !_this._mouseDrag) {
        _this.playPause();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onMouseDown", function (e) {
      if (e.target.localName === "canvas") {
        _this._mouseDown = true;
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onDoubleClick", function (e) {
      if (e.target.localName === "canvas") {
        _this.fullscreen();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "enableWakeLock", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (_this.props.wakeLock) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              if (!(!_this.cnt || !_this.cnt.player().playing())) {
                _context.next = 4;
                break;
              }
              return _context.abrupt("return");
            case 4:
              if (!(document.visibilityState !== "visible")) {
                _context.next = 6;
                break;
              }
              return _context.abrupt("return");
            case 6:
              if (!_this._wakeLock) {
                _context.next = 8;
                break;
              }
              return _context.abrupt("return");
            case 8:
              _context.prev = 8;
              _context.next = 11;
              return navigator.wakeLock.request("screen");
            case 11:
              _this._wakeLock = _context.sent;
              _this._wakeLock.addEventListener("release", function () {
                _this._wakeLock = null;
              });
              _context.next = 18;
              break;
            case 15:
              _context.prev = 15;
              _context.t0 = _context["catch"](8);
              console.error(_context.t0);
            case 18:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[8, 15]]);
    })));
    _defineProperty(_assertThisInitialized(_this), "disableWakeLock", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!_this._wakeLock) {
                _context2.next = 4;
                break;
              }
              _context2.next = 3;
              return _this._wakeLock.release();
            case 3:
              _this._wakeLock = null;
            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));
    _defineProperty(_assertThisInitialized(_this), "latestApple", function () {
      if (_this.cnt && _this.cnt.player().appleTimes()) {
        var latestApple = _this.cnt.player().appleTimes().sort(function (a, b) {
          return b.frame - a.frame;
        }).find(function (appleTime) {
          return appleTime.frame <= _this.state.currentFrame;
        });
        if (latestApple) {
          return {
            apple: latestApple.apple,
            time: _this.frameToTimestamp(latestApple.frame)
          };
        }
        return null;
      }
    });
    _defineProperty(_assertThisInitialized(_this), "zoom", function (action) {
      if (_this.cnt && _this.cnt.player()) {
        var pl = _this.cnt.player();
        var scale = pl.scale();
        if (action === "in") {
          pl.setScale(scale * 1.2);
        }
        if (action === "out") {
          pl.setScale(scale / 1.2);
        }
      }
    });
    _defineProperty(_assertThisInitialized(_this), "reverse", function () {
      if (_this.cnt && _this.cnt.player()) {
        var pl = _this.cnt.player();
        var speed = pl.speed();
        pl.setSpeed(-speed);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "speed", function (action) {
      if (_this.cnt && _this.cnt.player()) {
        var pl = _this.cnt.player();
        var speed = pl.speed();
        if (action === "faster") {
          pl.setSpeed(speed / 0.8);
        }
        if (action === "slower") {
          pl.setSpeed(speed * 0.8);
        }
      }
    });
    _defineProperty(_assertThisInitialized(_this), "getSpeed", function () {
      if (_this.cnt && _this.cnt.player()) {
        var pl = _this.cnt.player();
        var speed = pl.speed();
        if (speed) {
          return "".concat(parseFloat(Math.abs(speed)).toFixed(2), "x");
        }
        return "1.00x";
      }
    });
    _this.state = {
      playing: props.autoPlay || false,
      fullscreen: false,
      maxFrames: 0,
      progressBarDrag: false,
      currentFrame: 0
    };
    _this.playerContainerRef = /*#__PURE__*/React.createRef();
    return _this;
  }
  _createClass(RecPlayer, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (!isNaN(this.props.frame) && this.props.frame !== prevProps.frame) {
        this.goToFrame(this.props.frame);
      }
      if (this.props.levUrl !== prevProps.levUrl) {
        this.recreateController(this.props.recUrl, this.props.levUrl, this.props.shirtUrl);
        return;
      }
      if (this.props.recUrl !== prevProps.recUrl && this.props.recUrl) {
        this.changeReplays(this.props.recUrl, this.props.shirtUrl);
        return;
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this._isMounted = true;
      this._wakeLock = null;
      window.addEventListener("resize", this.autoResize);
      document.addEventListener("mouseup", this.onMouseUp);
      document.addEventListener("mousemove", this.onMouseMove);
      document.addEventListener("visibilitychange", this.enableWakeLock);
      this.initPlayer({
        levUrl: this.props.levUrl,
        recUrl: this.props.recUrl,
        shirtUrl: this.props.shirtUrl
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._isMounted = false;
      window.removeEventListener("resize", this.autoResize);
      document.removeEventListener("mouseup", this.onMouseUp);
      document.removeEventListener("mousemove", this.onMouseMove);
      document.removeEventListener("visibilitychange", this.enableWakeLock);
      this.removeAnimationLoop();
      this.disableWakeLock();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var className = this.state.fullscreen ? "RecPlayer RecPlayer-fullscreen" : "RecPlayer";
      if (this.state.progressBarDrag) className += " RecPlayer-progressBar-drag";
      return /*#__PURE__*/React.createElement("div", {
        style: {
          height: this.props.height === "auto" ? "100%" : this.props.height + "px",
          width: this.props.width === "auto" ? "100%" : this.props.width + "px"
        },
        className: className,
        onClick: this.onClick,
        onMouseDown: this.onMouseDown,
        onDoubleClick: this.onDoubleClick
      }, /*#__PURE__*/React.createElement("div", {
        className: "RecPlayer-player-container",
        onTouchStart: this.playerContainerOnTouchStart,
        onTouchEnd: this.playerContainerOnTouchEnd,
        onTouchMove: this.playerContainerOnTouchMove,
        tabIndex: "0",
        ref: this.playerContainerRef
      }, this.props.controls && /*#__PURE__*/React.createElement("div", {
        className: "RecPlayer-controls"
      }, /*#__PURE__*/React.createElement("div", {
        className: "RecPlayer-controls-progress-bar",
        ref: function ref(el) {
          return _this2._progressBar = el;
        },
        onMouseDown: function onMouseDown(e) {
          return _this2.progressBarOnMouseDown(e);
        },
        onTouchMove: function onTouchMove(e) {
          return _this2.progressBarOnTouchMove(e);
        },
        onTouchStart: this.progressBarOnTouchStart,
        onTouchEnd: this.progressBarOnTouchEnd
      }, /*#__PURE__*/React.createElement("div", {
        className: "RecPlayer-controls-progress-bar-background"
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          width: this.state.progress + "%"
        },
        className: "RecPlayer-controls-progress-bar-progress"
      }))), /*#__PURE__*/React.createElement("div", {
        className: "RecPlayer-controls-bottom-row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "RecPlayer-controls-button",
        style: this.state.playing ? {
          display: "none"
        } : {},
        onClick: this.playPause
      }, /*#__PURE__*/React.createElement("img", {
        src: img$7
      })), /*#__PURE__*/React.createElement("div", {
        className: "RecPlayer-controls-button",
        style: !this.state.playing ? {
          display: "none"
        } : {},
        onClick: this.playPause
      }, /*#__PURE__*/React.createElement("img", {
        src: img$6
      })), /*#__PURE__*/React.createElement("div", {
        className: "Recplayer-controls-text RecPlayer-controls-timestamp"
      }, this.frameToTimestamp(this.state.currentFrame)), /*#__PURE__*/React.createElement("div", {
        className: "RecPlayer-controls-button RecPlayer-controls-button-fullscreen",
        onClick: this.fullscreen,
        title: "Fullscreen"
      }, /*#__PURE__*/React.createElement("img", {
        src: img$5
      })), this.props.showPlaybackBtns ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "RecPlayer-controls-button RecPlayer-controls-button-zoom",
        onClick: function onClick() {
          return _this2.speed("faster");
        },
        title: "Faster playback speed"
      }, /*#__PURE__*/React.createElement("img", {
        src: img$1
      })), /*#__PURE__*/React.createElement("div", {
        className: "Recplayer-controls-text RecPlayer-controls-speed-text"
      }, this.getSpeed()), /*#__PURE__*/React.createElement("div", {
        className: "RecPlayer-controls-button RecPlayer-controls-button-zoom",
        onClick: function onClick() {
          return _this2.speed("slower");
        },
        title: "Slower playback speed"
      }, /*#__PURE__*/React.createElement("img", {
        src: img
      })), /*#__PURE__*/React.createElement("div", {
        className: "RecPlayer-controls-button RecPlayer-controls-button-zoom",
        onClick: function onClick() {
          return _this2.reverse();
        },
        title: "Reverse playback"
      }, /*#__PURE__*/React.createElement("img", {
        src: img$2
      }))) : null, this.props.showZoomBtns ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "RecPlayer-controls-button RecPlayer-controls-button-zoom",
        onClick: function onClick() {
          return _this2.zoom("in");
        },
        title: "Zoom in"
      }, /*#__PURE__*/React.createElement("img", {
        src: img$3
      })), /*#__PURE__*/React.createElement("div", {
        className: "RecPlayer-controls-button RecPlayer-controls-button-zoom",
        onClick: function onClick() {
          return _this2.zoom("out");
        },
        title: "Zoom out"
      }, /*#__PURE__*/React.createElement("img", {
        src: img$4
      }))) : null, /*#__PURE__*/React.createElement("div", {
        className: "Recplayer-controls-text RecPlayer-controls-latest-apple"
      }, this.cnt && this.latestApple() && /*#__PURE__*/React.createElement("div", null, this.latestApple().time, " (", this.latestApple().apple, ")"))))));
    }
  }]);
  return RecPlayer;
}(React.Component);

module.exports = RecPlayer;
